import { priorityTranslations } from '../data/industryPriorities';
import { industryTranslations } from '../data/industryExpansion';
const studyTranslations = {
    "Como iniciar a adoção de IA em 90 dias": "How to start AI adoption in 90 days",
    "Um roteiro prático para escolher o primeiro caso, estruturar o piloto, medir valor e preparar a expansão.": "A practical roadmap to choose your first use case, structure a pilot, measure value and prepare to scale.",
    "Checklist de governança e segurança para IA": "AI governance and security checklist",
    "Controles essenciais para dados, acessos, agentes, modelos, auditoria, ModelOps e FinOps.": "Essential controls for data, access, agents, models, auditing, ModelOps and FinOps.",
    "Como calcular o custo real da IA na empresa": "How to calculate the real cost of enterprise AI",
    "Um modelo para comparar licenças por usuário, consumo, implantação e custo operacional.": "A framework to compare per-user licenses, usage, implementation and operating costs.",
};
export const EN_US_TEXT = {
...studyTranslations,
...industryTranslations,
...priorityTranslations,
"Indústrias": "Industries",
"Departamentos": "Departments",
"IA conectada aos desafios da sua indústria.": "AI connected to your industry’s challenges.",
"Da indústria de transformação aos serviços, conecte conhecimento, documentos e processos para apoiar suas equipes. Explore as oportunidades de IA no contexto da sua operação.": "From manufacturing to services, connect knowledge, documents and processes to support your teams. Explore AI opportunities in the context of your operation.",
"Plano Enterprise": "Enterprise plan",
"Plano Free": "Free plan",
"Plano Lite": "Lite plan",
"Plano Basic": "Basic plan",
"Plano Start": "Start plan",
"Plano Growth": "Growth plan",
"Plano Pro": "Pro plan",
"Adoção de IA": "AI adoption",
"A assinatura considera o tamanho da empresa. O consumo das APIs é cobrado separadamente pelos provedores.": "Your subscription is based on company size. API usage is billed separately by the providers.",
"Proposta sob consulta, com suporte Enterprise e opções de infraestrutura e banco de dados dedicados. O consumo das APIs é cobrado separadamente pelos provedores.": "Pricing on request, with Enterprise support and dedicated infrastructure and database options. API usage is billed separately by the providers.",
"Torre de controle logística com IA: antecipe exceções e coordene a operação.": "AI logistics control tower: anticipate exceptions and coordinate operations.",
"Torre de controle logística": "Logistics control tower",
"Conecte pedidos, transportadoras e sistemas de gestão em uma visão operacional. Use IA para acompanhar entregas, priorizar ocorrências e manter clientes e parceiros informados.": "Connect orders, carriers and management systems in one operational view. Use AI to track deliveries, prioritize incidents and keep customers and partners informed.",
"Visibilidade ponta a ponta": "End-to-end visibility",
"Integre dados de TMS, WMS, ERP e parceiros para reunir coletas, entregas, prazos e comprovantes em um só fluxo.": "Integrate TMS, WMS, ERP and partner data to bring pickups, deliveries, deadlines and delivery receipts into one workflow.",
"Exceções priorizadas": "Prioritized exceptions",
"Identifique atrasos, falta de atualização e divergências. Agentes organizam as ocorrências por impacto e SLA, com responsável e próxima ação.": "Identify delays, missing updates and discrepancies. Agents organize incidents by impact and SLA, with an owner and next action.",
"Comunicação coordenada": "Coordinated communication",
"Automatize consultas de status e atualizações por canais conectados. Negociações, reprogramações e casos críticos seguem para aprovação humana.": "Automate status queries and updates through connected channels. Negotiations, rescheduling and critical cases go to human approval.",
"Decisões com evidência": "Evidence-based decisions",
"Acompanhe indicadores de entrega e recorrência de problemas com histórico de ações, documentos e decisões para melhorar a operação.": "Track delivery indicators and recurring problems with a history of actions, documents and decisions to improve operations.",
"Exceções": "Exceptions",
"Engenharia civil: transforme dados de projetos em decisões com IA.": "Civil engineering: turn project data into decisions with AI.",
"IA para engenharia civil": "AI for civil engineering",
"Integre AutoCAD e SketchUp aos processos da sua empresa para extrair e organizar dados de projetos de engenharia. Reduza levantamentos manuais e conecte informações de projeto a orçamento, planejamento e acompanhamento da obra.": "Integrate AutoCAD and SketchUp with your business processes to extract and organize engineering project data. Reduce manual takeoffs and connect project information to estimating, planning and construction monitoring.",
"Projetos conectados": "Connected projects",
"Estruturamos a integração com AutoCAD e SketchUp conforme as versões, os formatos e os dados disponíveis, conectando arquivos, exportações ou interfaces de integração ao fluxo da empresa.": "We design the AutoCAD and SketchUp integration around available versions, formats and data, connecting files, exports or integration interfaces to your business workflow.",
"Extração de dados de engenharia": "Engineering data extraction",
"Organize atributos, dimensões, áreas, volumes e quantitativos quando presentes nos desenhos e modelos. Preserve a origem e a revisão do projeto para conferir cada informação.": "Organize attributes, dimensions, areas, volumes and quantities when present in drawings and models. Preserve the source and project revision so each item can be checked.",
"Do projeto à gestão": "From design to management",
"Leve os dados extraídos para planilhas, ERP e ferramentas de planejamento por meio dos conectores disponíveis, apoiando orçamentos, compras e acompanhamento de alterações.": "Send extracted data to spreadsheets, ERP and planning tools through available connectors, supporting estimates, procurement and change tracking.",
"Validação pela engenharia": "Engineering review",
"O responsável técnico revisa quantitativos, divergências e informações incompletas antes de liberar os dados para decisões de orçamento, compra ou execução.": "The responsible engineer reviews quantities, discrepancies and incomplete information before releasing data for estimating, purchasing or execution decisions.",
"Quantitativos": "Quantities",
"Revisão técnica": "Technical review",
"Engenharia civil": "Civil engineering",
"Converse com um especialista para definir sistemas, dados e escopo do primeiro fluxo.": "Talk to an expert to define systems, data and scope for your first workflow.",

    "Consultoria para transformar IA em resultado.": "Consulting to turn AI into business results.",
    "Automatize processos, acelere a adoção, democratize o acesso à IA e tome melhores decisões de investimento com FinOps. A Zild conecta estratégia, pessoas e sistemas para levar sua empresa do plano à prática.": "Automate processes, accelerate adoption, democratize AI access and make better investment decisions with FinOps. Zild connects strategy, people and systems to take your company from plans to practice.",
    "Automação": "Automation",
    "Adoção": "Adoption",
    "Democratização": "Democratization",
    "A plataforma para operar agentes de IA com": "The platform to operate AI agents with",
    "controle humano.": "human control.",
    "Orquestre agentes, políticas, handoffs e evidências em uma camada operacional. A Zild ajuda seu time a levar pilotos para rotinas reais de atendimento, vendas, voz, documentos e backoffice.":
        "Orchestrate agents, policies, handoffs and evidence in one operational layer. Zild helps your team move pilots into real service, sales, voice, document and back-office routines.",
    "Ver a plataforma": "See the platform",
    "Falar com especialista": "Talk to an expert",
    "Falar com a Zild pelo WhatsApp": "Talk to Zild on WhatsApp",
    "POLÍTICA ANTES DA AÇÃO": "POLICY BEFORE ACTION",
    "HUMANO NOS CASOS SENSÍVEIS": "HUMAN IN SENSITIVE CASES",
    "EVIDÊNCIA PARA AUDITORIA": "EVIDENCE FOR AUDIT",
    "Clientes e parceiros que já confiam na Zild.": "Clients and partners already trusting Zild.",
    "Sete módulos. Um único loop de operação.": "Seven modules. One operating loop.",
    "CONSOLE DE OPERAÇÃO": "OPERATIONS CONSOLE",
    "ATENDIMENTO CONVERSACIONAL": "CONVERSATIONAL SERVICE",
    "GPT INTERNO SEGURO": "SECURE INTERNAL GPT",
    "TELEFONIA GOVERNADA": "GOVERNED TELEPHONY",
    "DESEMPENHO OPERACIONAL": "OPERATIONAL PERFORMANCE",
    "DOCUMENTOS E INTAKE": "DOCUMENTS AND INTAKE",
    "TRABALHO DE RETAGUARDA": "BACK-OFFICE WORK",
    "TREINAMENTO E SIMULAÇÃO": "TRAINING AND SIMULATION",
    "Mapa de agentes, papéis e dados. Permissões, políticas, trilha de auditoria, modelos de IA conectados, filas e estados — tudo em uma camada de governança única.":
        "A map of agents, roles and data. Permissions, policies, audit trail, connected AI models, queues and states, all in one governance layer.",
    "Roster de agentes humanos e de IA": "Roster of human and AI agents",
    "Permissões por papel (RBAC)": "Role-based permissions (RBAC)",
    "Modelos de IA conectados e quotas": "Connected AI models and quotas",
    "Trilha de auditoria por turno": "Audit trail by operational turn",
    "Documentação do módulo": "Module documentation",
    "SINAIS OBSERVADOS": "OBSERVED SIGNALS",
    "Auditoria": "Audit",
    "TRILHA POR TURNO": "TRAIL BY TURN",
    "Por papel": "By role",
    "Agentes em WhatsApp, e-mail e canais privados, com contexto unificado, conexão com sistemas internos e validação humana sob política.":
        "Agents on WhatsApp, email and private channels, with unified context, internal system connections and human validation under policy.",
    "Agentes em WhatsApp, e-mail e canais privados, com contexto unificado e validação humana sob política.":
        "Agents on WhatsApp, email and private channels, with unified context and human validation under policy.",
    "WhatsApp, e-mail e canais privados": "WhatsApp, email and private channels",
    "Contexto unificado por cliente e ticket": "Unified context by customer and ticket",
    "Validação humana com fila e SLA": "Human validation with queue and SLA",
    "Pacote de evidências por conversa": "Evidence package for each conversation",
    "Ambiente corporativo para colaboradores usarem IA com contexto da empresa, bases autorizadas e políticas de uso, sem levar informação sensível para ferramentas soltas.":
        "A corporate environment for employees to use AI with company context, authorized knowledge bases and usage policies, without moving sensitive information into loose tools.",
    "Copiloto interno para colaboradores": "Internal copilot for employees",
    "Conexão com informações estratégicas": "Connection to strategic information",
    "Acesso por papel e base autorizada": "Access by role and authorized source",
    "Histórico e evidência de uso": "Usage history and evidence",
    "Recepção, callback e prospecção por voz com transcrição em tempo real, scoring por chamada e revisão por monitoria.":
        "Reception, callback and voice prospecting with real-time transcription, call scoring and monitoring review.",
    "Discador, recepção e callback": "Dialer, reception and callback",
    "Transcrição e scoring em tempo real": "Real-time transcription and scoring",
    "Compatível com PABX e CCaaS": "Compatible with PBX and CCaaS",
    "Tags por compliance e por critério": "Tags by compliance and criteria",
    "Painéis por papel, fila, canal, departamento e fluxo. Compare humano e agente. Detecte risco e queda de qualidade antes do cliente sentir.":
        "Dashboards by role, queue, channel, department and workflow. Compare human and agent work. Detect risk and quality drops before the customer feels them.",
    "Scorecards por função e fila": "Scorecards by function and queue",
    "Comparativo humano × agente": "Human vs. agent comparison",
    "Alertas operacionais por trend": "Operational alerts by trend",
    "Exportação para BI corporativo": "Export to corporate BI",
    "Leitura assistida de contratos, PDFs e formulários, com extração estruturada, validação contra políticas e fila de exceção.":
        "Assisted reading of contracts, PDFs and forms, with structured extraction, validation against policies and an exception queue.",
    "OCR + extração estruturada": "OCR + structured extraction",
    "Validação contra políticas": "Validation against policies",
    "Roteamento por exceção": "Exception routing",
    "Integração com ECM e CRM": "ECM and CRM integration",
    "Cobrança, follow-up, atualização de CRM e tarefas internas executadas por agentes — com responsável humano por exceção e prazo claro.":
        "Collections, follow-up, CRM updates and internal tasks executed by agents, with a human owner for exceptions and clear deadlines.",
    "Tarefas com responsável e SLA": "Tasks with owner and SLA",
    "Atualização de CRM por agente": "Agent-driven CRM updates",
    "Follow-up automatizado e revisável": "Automated, reviewable follow-up",
    "Workflows internos com handoff": "Internal workflows with handoff",
    "Construa cenários, simule conversas, avalie respostas contra critério e devolva planos de coaching individuais para humanos e agentes.":
        "Build scenarios, simulate conversations, evaluate responses against criteria and return individual coaching plans for humans and agents.",
    "Roleplay por persona e cenário": "Roleplay by persona and scenario",
    "Avaliação por critério customizado": "Evaluation by custom criteria",
    "Plano individual por agente": "Individual plan by agent",
    "Trilhas de capacitação": "Training paths",

    "Cada solicitação vira um turno operacional.": "Every request becomes an operational turn.",
    "A Zild recebe o contexto, aplica políticas, permite a ação segura e mantém evidência para o próximo ciclo.":
        "Zild receives context, applies policies, allows safe action and keeps evidence for the next cycle.",
    "Entrada, política, ação e evidência no mesmo registro.": "Input, policy, action and evidence in the same record.",
    "A solicitação chega com contexto.": "The request arrives with context.",
    "Canal, cliente, intenção, histórico e SLA entram no mesmo turno.": "Channel, customer, intent, history and SLA enter the same turn.",
    "A política define o que pode acontecer.": "Policy defines what can happen.",
    "Papel, dado permitido, limite de risco e próxima ação são checados antes da execução.":
        "Role, allowed data, risk limit and next action are checked before execution.",
    "Agente quando é seguro. Humano quando importa.": "Agent when it is safe. Human when it matters.",
    "A operação avança sem perder responsabilidade quando uma decisão pede contexto.":
        "The operation moves forward without losing accountability when a decision needs context.",
    "O registro volta para melhorar o sistema.": "The record returns to improve the system.",
    "Resultado, QA, custo e coaching alimentam o próximo ciclo.": "Outcome, QA, cost and coaching feed the next cycle.",
    "Humano assume risco ou exceção": "Human handles risk or exception",
    "Próximo turno": "Next turn",

    "O rastro humano que fica quando a IA opera.": "The human trail that remains when AI operates.",
    "Zild vem de Zilda, avó da Ana, co-fundadora da Zild. O símbolo nasce da marca que uma xícara de café deixa na mesa depois de uma conversa.":
        "Zild comes from Zilda, grandmother of Ana, Zild's co-founder. The symbol comes from the mark a coffee cup leaves on the table after a conversation.",
    "Essa marca virou princípio de produto: antes de um agente agir, alguém entende o contexto, combina limites e assume responsabilidade. Depois de cada turno, fica a evidência do que aconteceu.":
        "That mark became a product principle: before an agent acts, someone understands the context, agrees on limits and takes responsibility. After each turn, evidence of what happened remains.",
    "Conversa antes da automação": "Conversation before automation",
    "O processo é entendido antes de virar agente.": "The process is understood before becoming an agent.",
    "Humano quando importa": "Human when it matters",
    "Risco, exceção e decisão ficam com uma pessoa responsável.": "Risk, exception and decision stay with an accountable owner.",
    "Evidência depois da ação": "Evidence after action",
    "Cada turno deixa registro para revisão, QA e melhoria.": "Each turn leaves a record for review, QA and improvement.",

    "Escolha o primeiro fluxo pela pressão operacional, não pelo hype.": "Choose the first workflow by operational pressure, not hype.",
    "Atendimento": "Service",
    "Vendas": "Sales",
    "Voz": "Voice",
    "Documentos": "Documents",
    "Backoffice": "Back office",
    "Monitoria": "Monitoring",
    "Entrada": "Intake",
    "Política": "Policy",
    "Ação": "Action",
    "Evidência": "Evidence",
    "Humano": "Human",
    "Melhoria": "Improvement",
    "Risco": "Risk",
    "Controle": "Control",
    "Configurar": "Configure",
    "Operar": "Operate",
    "Controlar": "Control",
    "Melhorar": "Improve",

    "Governança que aparece no produto, não em relatório solto.": "Governance that appears in the product, not in a loose report.",
    "Antes da ação": "Before action",
    "Durante o turno": "During the turn",
    "Depois da execução": "After execution",
    "Registro preservado": "Record preserved",
    "Agente identifica intenção": "Agent identifies intent",
    "Política aplicada": "Policy applied",
    "Humano valida exceção": "Human validates exception",
    "Evidência alimenta melhoria": "Evidence feeds improvement",

    "Plataforma neutra de modelo, integrada ao que a operação já usa.": "Model-neutral platform, integrated with what the operation already uses.",
    "Modelo e provedor": "Model and provider",
    "Canais e telefonia": "Channels and telephony",
    "Sistemas internos": "Internal systems",
    "Dados e documentos": "Data and documents",
    "Observabilidade": "Observability",

    "Traga um fluxo real. Saia com o mapa de operação.": "Bring a real workflow. Leave with the operating map.",
    "A primeira conversa deve produzir uma decisão útil: onde a IA entra, onde ela para, quem assume exceções e qual evidência fica.":
        "The first conversation should produce a useful decision: where AI enters, where it stops, who handles exceptions and what evidence remains.",
    "Agendar conversa": "Book a conversation",
    "Fluxo": "Workflow",
    "A operação que vale colocar em produção primeiro.": "The operation worth putting into production first.",
    "Fronteira": "Boundary",
    "O que o agente pode fazer e quando precisa parar.": "What the agent can do and when it must stop.",
    "Prova": "Proof",
    "Que evidência fica para medir, revisar e melhorar.": "What evidence remains to measure, review and improve.",

    "Sete módulos. Uma camada de governança. Uma operação.": "Seven modules. One governance layer. One operation.",
    "Operação desenhada antes da automação": "Operation designed before automation",
    "Camada comum": "Shared layer",
    "Canais": "Channels",
    "Cliente entra por atendimento ou voz": "Customers enter through service or voice",
    "Assist e Voice absorvem a linha de frente, mantendo fila, contexto e handoff humano sob a mesma política.":
        "Assist and Voice handle the front line while keeping queue, context and human handoff under the same policy.",
    "Conhecimento": "Knowledge",
    "Colaborador usa IA com contexto autorizado": "Employees use AI with authorized context",
    "Chat e Tasks conectam perguntas internas, documentos e próximos passos em um ambiente controlado.":
        "Chat and Tasks connect internal questions, documents and next steps in a controlled environment.",
    "Resultado volta para o ciclo": "The result returns to the cycle",
    "Insight mede por papel e canal; Coach transforma evidência em treino para agentes humanos e de IA.":
        "Insight measures by role and channel; Coach turns evidence into training for human and AI agents.",

    "Comece pelo fluxo que já pressiona a operação.": "Start with the workflow that is already straining operations.",
    "Atendimento, vendas, voz, documentos e backoffice entram no mesmo modelo: regra antes da ação, humano quando importa e evidência para melhorar.":
        "Service, sales, voice, documents and back office enter the same model: rule before action, human when it matters and evidence to improve.",
    "Mapa de soluções": "Solution map",
    "IA para atendimento e SAC": "AI for support and customer service",
    "IA SDR e vendas": "AI SDR and sales",
    "IA para outbound e cobrança": "AI for outbound and collections",
    "IA para voz e recepção": "AI for voice and reception",
    "IA para monitoria de qualidade": "AI for quality monitoring",
    "IA para documentos": "AI for documents",
    "IA para backoffice": "AI for back office",
    "Projeto de IA sob medida": "Custom AI project",

    "Setores diferentes, o mesmo modelo de supervisão.": "Different industries, the same supervision model.",
    "Comece pelo trabalho que o time reconhece: entrada, política, sistemas, validação humana, evidência e próxima ação.":
        "Start with work the team recognizes: intake, policy, systems, human validation, evidence and next action.",
    "Saúde": "Healthcare",
    "Serviços financeiros": "Financial services",
    "Logística": "Logistics",
    "Operações de cliente": "Customer operations",

    "Cada agente opera dentro de uma fronteira visível.": "Every agent operates inside a visible boundary.",
    "Permissões, modelos, fallback, revisão humana, auditoria e evidência deixam a operação pronta para escalar sem perder controle.":
        "Permissions, models, fallback, human review, audit and evidence make the operation ready to scale without losing control.",
    "Permissão": "Permission",
    "Agentes e pessoas atuam por papel, operação, canal e dado autorizado.": "Agents and people act by role, operation, channel and authorized data.",
    "Ação segura, validação obrigatória e bloqueio ficam configurados antes da produção.": "Safe action, required validation and blocking rules are configured before production.",
    "Transcrição, decisão, custo, resultado e responsável permanecem revisáveis.": "Transcription, decision, cost, result and owner remain reviewable.",
    "A operação sabe o que ajustar, expandir, pausar ou treinar.": "The operation knows what to adjust, expand, pause or train.",

    "Planos para operar agentes com consumo previsível.": "Plans to operate agents with predictable consumption.",
    "Gostaria de uma demonstração sem compromisso?": "Would you like a no-commitment demo?",
    "Agendar demonstração": "Schedule a demo",
    "Sob consulta": "Contact us",
    "Plano": "Plan",
    "Créditos": "Credits",
    "Mensagens": "Messages",
    "Minutos": "Minutes",
    "Documentos": "Documents",

    "Nosso agente de IA faz o primeiro atendimento": "Our AI agent handles the first response",
    "Fale com o time agora": "Talk to the team now",
    "Comece pelo WhatsApp. Quando estamos online, costumamos responder em poucos minutos.":
        "Start on WhatsApp. When we are online, we usually respond within a few minutes.",
    "Fale conosco": "Talk to us",
    "Ligar agora": "Call now",
    "Telefone:": "Phone:",
    "Agendar demo": "Book a demo",
    "Solicitação registrada.": "Request received.",
    "Enviar nova solicitação": "Send another request",
    "Enviando...": "Sending...",
    "Suas informações são tratadas conforme a LGPD.": "Your information is handled according to LGPD.",
    "Política aplicada por papel": "Policy applied by role",
    "Handoff humano configurado": "Human handoff configured",
    "A Zild recebe o contexto, aplica políticas, permite a ação segura e preserva o rastro quando uma pessoa precisa decidir.":
        "Zild receives context, applies policies, enables safe action and preserves the trail when a person needs to decide.",
    "política, dono e evidência preservados": "policy, owner and evidence preserved",
    "Agente atua dentro da política": "Agent works inside the policy",
    "O ciclo não termina no atendimento.": "The cycle does not end with service.",
    "Políticas, coaching e evidência voltam para o começo do fluxo, melhorando o próximo turno sem virar um projeto separado.":
        "Policies, coaching and evidence return to the beginning of the workflow, improving the next turn without becoming a separate project.",
    "POLÍTICA ANTES DA AUTOMAÇÃO": "POLICY BEFORE AUTOMATION",
    "A camada humana para operar agentes de IA com regra, confiança e evidência.":
        "The human layer to operate AI agents with rules, trust and evidence.",
    "PLATAFORMA": "PLATFORM",
    "SOLUÇÕES": "SOLUTIONS",
    "Setores": "Industries",
    "Confiança": "Trust",
    "Implementação": "Implementation",
    "Preços": "Pricing",
    "Documentação": "Documentation",
    "papéis · dados · política · auditoria": "roles · data · policy · audit",
    "papel, política, limite": "role, policy, limit",
    "Mapa de agentes, papéis, dados, permissões, modelos conectados, políticas e trilha de auditoria em uma camada comum.":
        "A map of agents, roles, data, permissions, connected models, policies and audit trail in one shared layer.",
    "Política antes da ação": "Policy before action",
    "Caixas unificadas por fila e operação": "Unified inboxes by queue and operation",
    "Macros e respostas guiadas por política": "Macros and replies guided by policy",
    "Validação humana com SLA por canal": "Human validation with SLA by channel",
    "Informação estratégica com contexto": "Strategic information with context",
    "Leitura assistida de contratos, PDFs e formulários, com extração estruturada e fila de exceção.":
        "Assisted reading of contracts, PDFs and forms, with structured extraction and an exception queue.",
    "OCR e extração estruturada": "OCR and structured extraction",
    "Validação contra política": "Validation against policy",
    "Cobrança, follow-up, atualização de CRM e tarefas internas executadas por agentes com responsável humano por exceção.":
        "Collections, follow-up, CRM updates and internal tasks executed by agents with a human owner for exceptions.",
    "Painéis por papel, fila, canal e operação para comparar humano e agente e detectar queda de qualidade cedo.":
        "Dashboards by role, queue, channel and operation to compare human and agent work and detect quality drops early.",
    "Comparativo humano x agente": "Human vs. agent comparison",
    "Cenários, conversas simuladas, avaliação por critério e planos de coaching individuais.":
        "Scenarios, simulated conversations, criteria-based evaluation and individual coaching plans.",
    "Plano individual por agente humano e IA": "Individual plan by human and AI agent",
    "Solução, aqui, não é um pacote genérico. É um fluxo com entrada, regra, humano responsável, evidência e próximo passo.":
        "Here, a solution is not a generic package. It is a workflow with intake, rule, accountable human, evidence and next step.",
    "A operação sabe o que a IA pode fazer e onde uma pessoa assume.":
        "The operation knows what AI can do and where a person takes over.",
    "Resultado, custo, motivo e próxima ação podem ficar registrados.":
        "Result, cost, reason and next action can remain recorded.",
    "O Assist resolve rotinas de atendimento, leva momentos sensíveis para pessoas e mantém evidência pronta para QA.":
        "Assist resolves service routines, routes sensitive moments to people and keeps evidence ready for QA.",
    "Baixa confiança, risco de política, SLA pressionado ou cliente crítico passam para uma pessoa.":
        "Low confidence, policy risk, pressured SLA or critical customer cases go to a person.",
    "Evidência capturada": "Captured evidence",
    "TELEFONE INTERROMPE OPERAÇÃO": "PHONE INTERRUPTS OPERATION",
    "Atendimento telefônico com classificação de intenção, transferência assistida, transcrição e evidência.":
        "Phone service with intent classification, assisted transfer, transcription and evidence.",
    "A ligação segue para área, fila ou retorno conforme regra operacional.":
        "The call moves to a team, queue or callback according to the operational rule.",
    "Qualificação, contexto do lead, objeções, atualização de CRM e handoff para vendedores em um fluxo supervisionado.":
        "Qualification, lead context, objections, CRM updates and handoff to sellers in a supervised workflow.",
    "Qualificação": "Qualification",
    "Campos, etapa, motivo e próxima ação ficam registrados para liderança comercial.":
        "Fields, stage, reason and next action stay recorded for sales leadership.",
    "Contato ativo por e-mail, voz e WhatsApp com política, contexto de conta e próxima ação clara.":
        "Active outreach by email, voice and WhatsApp with policy, account context and a clear next action.",
    "Mensagens e chamadas respeitam tom, janela, política e limites de cobrança.":
        "Messages and calls follow tone, time window, policy and collections limits.",
    "Promessa, contestação, cliente sensível ou baixa confiança vai para humano.":
        "Promise, dispute, sensitive customer or low confidence goes to a human.",
    "Resultado, tentativa, custo e próxima ação alimentam Tasks e Insight.":
        "Result, attempt, cost and next action feed Tasks and Insight.",
    "Classificação, extração, checklist e exceções com revisão humana quando a decisão tem risco.":
        "Classification, extraction, checklist and exceptions with human review when the decision carries risk.",
    "Extração e checklist": "Extraction and checklist",
    "O agente extrai dados, marca confiança e compara contra regra.":
        "The agent extracts data, marks confidence and compares against the rule.",
    "Baixa confiança, campo ausente ou risco de política vai para uma pessoa.":
        "Low confidence, missing field or policy risk goes to a person.",
    "MAPA DE SETORES": "INDUSTRY MAP",
    "saúde": "healthcare",
    "SETORES": "INDUSTRIES",
    "O setor define o risco. A operação continua sendo desenhada por fluxo.":
        "The industry defines the risk. The operation is still designed by workflow.",
    "Em vez de vender uma vertical genérica, a Zild parte do trabalho concreto: entrada, regra, responsável e evidência.":
        "Instead of selling a generic vertical, Zild starts from concrete work: intake, rule, owner and evidence.",
    "Triagem, agendamento, confirmação, documentos e follow-up com política, privacidade e evidência.":
        "Triage, scheduling, confirmation, documents and follow-up with policy, privacy and evidence.",
    "POLÍTICA · COBRANÇA · AUDITORIA · QA": "POLICY · COLLECTIONS · AUDIT · QA",
    "Política · cobrança · auditoria · QA": "Policy · collections · audit · QA",
    "Política · Cobrança · Auditoria · QA": "Policy · Collections · Audit · QA",
    "política · cobrança · auditoria · QA": "policy · collections · audit · QA",
    "Atendimento, cobrança, documentos, risco operacional e QA com limites claros para cada decisão.":
        "Service, collections, documents, operational risk and QA with clear limits for each decision.",
    "Status de entrega, coleta, exceção, documento e comunicação com cliente em fluxos rastreáveis.":
        "Delivery status, pickup, exception, document and customer communication in traceable workflows.",
    "Atendimento, receita, retenção, QA e backoffice operando no mesmo modelo de controle.":
        "Service, revenue, retention, QA and back office operating in the same control model.",
    "O setor muda a restrição. A primeira decisão continua sendo o fluxo: entrada, regra, responsável, prova e próxima ação.":
        "The industry changes the constraint. The first decision is still the workflow: intake, rule, owner, proof and next action.",
    "Privacidade, cobrança, SLA, exceção ou qualidade.": "Privacy, collections, SLA, exception or quality.",
    "Permissão, política e prova antes da escala.": "Permission, policy and proof before scale.",
    "CAMADA DE CONFIANÇA": "TRUST LAYER",
    "Revise permissão, política e fallback antes da escala.": "Review permission, policy and fallback before scaling.",
    "A conversa certa aqui não é sobre mais automação. É sobre quais agentes podem agir, com quais dados e quando uma pessoa assume.":
        "The right conversation here is not about more automation. It is about which agents can act, with which data and when a person takes over.",
    "Papel, canal, operação e dado autorizado.": "Role, channel, operation and authorized data.",
    "Baixa confiança, risco ou exceção com dono.": "Low confidence, risk or exception with an owner.",
    "Os créditos são usados por atividades que um agente executa, como responder mensagens, processar documentos ou operar minutos de ligação.":
        "Credits are used by activities an agent performs, such as answering messages, processing documents or operating call minutes.",
    "Ideal para começar com automação básica no WhatsApp": "Ideal for starting with basic WhatsApp automation",
    "Para equipes em crescimento que precisam escalar o atendimento": "For growing teams that need to scale service",
    "Automação avançada com integrações e maior controle": "Advanced automation with integrations and more control",
    "Solução corporativa com segurança, SLA e personalização": "Enterprise solution with security, SLA and customization",
    "preços diferenciados": "custom pricing",
    "Como a cobrança funciona": "How billing works",
    "Ao ultrapassar o limite mensal, a operação pode seguir em pay-as-you-go ou bloquear uso até a renovação.":
        "After passing the monthly limit, the operation can continue with pay-as-you-go or block usage until renewal.",
    "Por minuto de ligação": "Per call minute",
    "Entre em contato para entender o plano, a camada de consumo e a operação inicial mais adequada.":
        "Contact us to understand the plan, consumption layer and most suitable initial operation.",
    "Trazemos um caso seu, como atendimento, voz, intake ou monitoria, e mapeamos em Zild.":
        "Bring one of your cases, such as service, voice, intake or monitoring, and we map it in Zild.",
    "Política antes do código": "Policy before code",
    "Discutimos limites de operação, handoff e fronteiras de dado antes de qualquer integração.":
        "We discuss operating limits, handoff and data boundaries before any integration.",
    "Você sai com um plano de implantação por operação, com critério e prazo.":
        "You leave with an implementation plan by operation, with criteria and timeline.",
    "Comece pelo WhatsApp. Nosso agente de IA faz o primeiro atendimento e encaminha para o time quando a conversa pede contexto comercial.":
        "Start on WhatsApp. Our AI agent handles the first response and routes to the team when the conversation needs commercial context.",
    "SOLICITAÇÃO · DEMO": "REQUEST · DEMO",
    "Solicitação · demo": "Request · demo",
    "solicitação · demo": "request · demo",
    "política antes da automação": "policy before automation",
    "Política antes da automação": "Policy before automation",
    "Humano nos casos sensíveis": "Human in sensitive cases",
    "Evidência para auditoria": "Evidence for audit",
    "Console de operação": "Operations console",
    "Atendimento conversacional": "Conversational service",
    "Treinamento e simulação": "Training and simulation",
    "Plataforma": "Platform",
    "Soluções": "Solutions",
    "Mapa de setores": "Industry map",
    "Camada de confiança": "Trust layer",
    "Telefone interrompe operação": "Phone interrupts operation",
    "telefone interrompe operação": "phone interrupts operation",
    "TELEFONE INTERROMPE OPERAÇÃO": "PHONE INTERRUPTS OPERATION",
    "Dono humano": "Human owner",
    "Evidência de produtividade": "Productivity evidence",
    "QA contínua com critérios, exemplos reais, sinais de risco, coaching e melhoria de política.":
        "Continuous QA with criteria, real examples, risk signals, coaching and policy improvement.",
    "O time define o que é bom atendimento, risco, tom, resolução e conformidade.":
        "The team defines good service, risk, tone, resolution and compliance.",
    "Avaliação contínua": "Continuous evaluation",
    "Conversas e chamadas são pontuadas com evidência e exemplos.":
        "Conversations and calls are scored with evidence and examples.",
    "Ação de melhoria": "Improvement action",
    "Tendências viram coaching, revisão de macro, ajuste de agente ou mudança de política.":
        "Trends become coaching, macro review, agent tuning or policy changes.",
    "Mapeie regras, sistemas, donos e evidências ao redor do fluxo que o seu time realmente roda.":
        "Map rules, systems, owners and evidence around the workflow your team actually runs.",
    "Desenho da operação": "Operating design",
    "O fluxo define o que o agente faz, quando valida e que evidência fica.":
        "The workflow defines what the agent does, when it validates and what evidence remains.",
    "Escala por evidência": "Scale by evidence",
    "Expansão depende de métricas, qualidade, custo e confiança operacional.":
        "Expansion depends on metrics, quality, cost and operational trust.",

    "CHECKLIST · GOVERNANÇA": "CHECKLIST · GOVERNANCE",
    "REGISTRO CONTÍNUO": "CONTINUOUS RECORD",
    "WhatsApp, voz, documento, CRM": "WhatsApp, voice, document, CRM",
    "CRITÉRIOS": "CRITERIA",
    "O turno deixa rastro para melhorar o próximo.": "The turn leaves a trail to improve the next.",
    "Resultado, responsável, motivo, QA e aprendizado ficam disponíveis para revisão.":
        "Outcome, owner, reason, QA and learning remain available for review.",
    "REGISTRO": "RECORD",
    "QA, coaching, auditoria": "QA, coaching, audit",
    "PRÓXIMO PASSO": "NEXT STEP",
    "Diagnosticar um fluxo": "Diagnose a workflow",
    "O que a reunião precisa resolver": "What the meeting needs to resolve",
    "O que o agente resolve, confirma ou passa para uma pessoa.":
        "What the agent resolves, confirms or hands to a person.",
    "A trilha que fica para revisar decisão, custo, SLA e qualidade.":
        "The trail left to review decision, cost, SLA and quality.",
    "HANDOFF VISÍVEL": "VISIBLE HANDOFF",
    "PRÓXIMO PASSO FECHADO": "CLOSED NEXT STEP",

    "canal, documento, tarefa": "channel, document, task",
    "Governança": "Governance",
    "Execução": "Execution",
    "score, auditoria, coaching": "score, audit, coaching",
    "Auditoria por turno": "Audit by turn",
    "RBAC por papel": "Role-based RBAC",
    "Recepção, callback e prospecção por voz com transcrição, scoring em tempo real e revisão por monitoria.":
        "Reception, callback and voice prospecting with transcription, real-time scoring and monitoring review.",
    "Recepção, callback e discador": "Reception, callback and dialer",
    "Compatível com Twilio, Aircall, Vonage": "Compatible with Twilio, Aircall and Vonage",
    "Copiloto corporativo para colaboradores consultarem informações estratégicas, documentos e agentes em um ambiente governado.":
        "Corporate copilot for employees to consult strategic information, documents and agents in a governed environment.",
    "Detecção de tendência por trend": "Trend detection",

    "Escolha o fluxo de IA pelo trabalho que precisa sair da fila.":
        "Choose the AI workflow by the work that needs to leave the queue.",
    "Diagnosticar primeiro fluxo": "Diagnose the first workflow",
    "Um fluxo só vale começar quando passa por quatro sinais.":
        "A workflow is worth starting when it passes four signals.",
    "O fluxo acontece toda semana e tem repetição suficiente para medir.":
        "The workflow happens every week and repeats enough to measure.",
    "Dono": "Owner",
    "Existe uma liderança que aceita regra, risco, SLA e exceção.":
        "There is an owner who accepts the rule, risk, SLA and exception path.",
    "Mapa de fluxos": "Workflow map",
    "1 fluxo": "1 workflow",
    "2 fluxos": "2 workflows",
    "FILA COM VOLUME, SLA E REPETIÇÃO": "QUEUE WITH VOLUME, SLA AND REPETITION",
    "Ver fluxo": "View workflow",
    "Módulos prováveis": "Likely modules",
    "Antes da Zild": "Before Zild",
    "Fluxo implantado": "Deployed workflow",
    "O agente identifica intenção, consulta contexto, resolve o que é seguro e prepara próximas ações.":
        "The agent identifies intent, checks context, resolves what is safe and prepares next actions.",
    "Transcrição, motivo da transferência, responsável, resultado, nota de qualidade e custo ficam juntos.":
        "Transcript, transfer reason, owner, outcome, quality score and cost stay together.",
    "Transferência assistida": "Assisted transfer",
    "Quando uma pessoa assume, recebe resumo, intenção, dados e histórico.":
        "When a person takes over, they receive summary, intent, data and history.",
    "Transcrição e score alimentam QA, coaching e ajustes de script.":
        "Transcript and score feed QA, coaching and script adjustments.",
    "LEAD ENTRA E FOLLOW-UP SE PERDE": "LEAD ENTERS AND FOLLOW-UP GETS LOST",
    "Entrada comercial": "Sales intake",
    "Leads chegam por formulário, WhatsApp, e-mail ou listas com origem e contexto.":
        "Leads arrive through forms, WhatsApp, email or lists with source and context.",
    "O agente aplica critérios, coleta lacunas, registra objeções e recomenda o próximo passo.":
        "The agent applies criteria, collects gaps, records objections and recommends the next step.",
    "Oportunidades quentes chegam ao vendedor com resumo, histórico e tarefa.":
        "Qualified opportunities reach the seller with summary, history and task.",
    "CARTEIRA EXIGE CONTATO ATIVO": "PORTFOLIO REQUIRES ACTIVE OUTREACH",
    "Contato governado": "Governed outreach",
    "Exceções com dono": "Owned exceptions",
    "DOCUMENTO VIRA RETRABALHO": "DOCUMENT BECOMES REWORK",
    "Documento recebido": "Document received",
    "Arquivos entram com origem, tipo, cliente e campos esperados.":
        "Files arrive with source, type, customer and expected fields.",
    "Revisão por exceção": "Exception review",
    "Próxima tarefa": "Next task",
    "O resultado fecha intake, atualiza sistemas e abre follow-up quando necessário.":
        "The result closes intake, updates systems and opens follow-up when needed.",
    "Enriquecimento, limpeza de CRM, tarefas recorrentes e exceções operacionais com responsável claro.":
        "Enrichment, CRM cleanup, recurring tasks and operational exceptions with a clear owner.",
    "O fluxo começa por tarefas repetidas que já consomem tempo do time.":
        "The workflow starts with repeated tasks already consuming team time.",
    "O agente consulta sistemas, atualiza registros e prepara exceções.":
        "The agent checks systems, updates records and prepares exceptions.",
    "Bloqueios, dúvidas e decisões sensíveis chegam com contexto para o responsável.":
        "Blocks, questions and sensitive decisions reach the owner with context.",
    "Tempo, volume, erro evitado e retrabalho ficam mensuráveis.":
        "Time, volume, avoided errors and rework become measurable.",
    "Critérios claros": "Clear criteria",
    "Visão executiva": "Executive view",
    "Liderança acompanha filas, canais, temas críticos e evolução por período.":
        "Leadership tracks queues, channels, critical themes and period-over-period movement.",
    "FLUXO CRÍTICO NÃO CABE EM CATEGORIA": "CRITICAL WORKFLOW DOES NOT FIT A CATEGORY",
    "Admin · Chat · módulos combinados": "Admin · Chat · combined modules",
    "A conversa identifica volume, donos, sistemas, risco, canais e critérios de sucesso.":
        "The conversation identifies volume, owners, systems, risk, channels and success criteria.",
    "A primeira versão roda com escopo estreito e revisão de cada exceção.":
        "The first version runs with narrow scope and review of every exception.",

    "Vertical muda. Controle não.": "The vertical changes. Control does not.",
    "Regra": "Rule",
    "Responsável": "Owner",
    "logística": "logistics",
    "operações": "operations",
    "02 REGRA": "02 RULE",
    "03 RESPONSÁVEL": "03 OWNER",
    "04 PROVA": "04 PROOF",
    "Ver desenho do setor": "View industry workflow",
    "STATUS · EXCEÇÃO · PARCEIROS · SLA": "STATUS · EXCEPTION · PARTNERS · SLA",
    "FILA · SLA · RETENÇÃO · COACHING": "QUEUE · SLA · RETENTION · COACHING",
    "CASO DO SETOR": "INDUSTRY CASE",
    "Escolha um caso com risco claro e dono operacional.":
        "Choose a case with clear risk and an operational owner.",
    "Mapear caso do setor": "Map the industry case",
    "RECORTE DE SETOR": "INDUSTRY SCOPE",
    "Operador": "Operator",
    "Quem responde pelo fluxo quando o agente para.":
        "Who owns the workflow when the agent stops.",
    "Registro": "Record",
    "O que precisa ficar auditável depois da execução.":
        "What needs to remain auditable after execution.",

    "auditoria": "audit",
    "O agente só executa dentro de um contrato operacional.":
        "The agent only executes inside an operational contract.",
    "A pergunta não é se a IA consegue agir. É qual papel pode agir, com qual dado, em qual fronteira e deixando qual prova.":
        "The question is not whether AI can act. It is which role can act, with which data, at which boundary and leaving which proof.",
    "FRONTEIRA DE CONTROLE": "CONTROL BOUNDARY",
    "Registro suficiente para revisar a decisão.": "Enough record to review the decision.",

    "Escolha a reserva de créditos de acordo com a sua necessidade. Quanto maior a reserva, maior o desconto por unidade de atividade de IA.":
        "Choose the credit reserve according to your need. The larger the reserve, the higher the discount per AI activity unit.",
    "Assinatura em créditos consumíveis": "Subscription in consumable credits",
    "PLANO": "PLAN",
    "mês, pago anualmente": "month, billed annually",
    "Quero esse plano": "Choose this plan",

    // Title Case labels that CSS uppercases visually (so the dictionary needs both cases)
    "Sinais observados": "Observed signals",
    "Trilha por turno": "Trail by turn",
    "Turno Zild": "Zild turn",
    "Contexto": "Context",
    "Em curso": "In progress",
    "Conformidade": "Compliance",
    "Por tenant": "Per tenant",
    "Limite": "Limit",
    "Modelos": "Models",
    "Sistemas": "Systems",
    "Sinais acompanhados": "Signals tracked",
    "30 minutos": "30 minutes",
    "Vendas / SDR": "Sales / SDR",
    "Sinal de impacto": "Impact signal",
    "Treinamento": "Training",

    // Governance audit ledger (full row labels)
    "Dados isolados": "Isolated data",
    "Política aplicada": "Policy applied",
    "Agente identifica intenção": "Agent identifies intent",
    "Risco operacional detectado": "Operational risk detected",
    "Handoff humano acionado": "Human handoff triggered",
    "Conversa encerrada": "Conversation closed",
    "contrato do turno": "turn contract",
    "bloqueio aplicado": "block applied",
    "trilha pronta": "trail ready",
    "Regra": "Rule",
    "Ação": "Action",
    "Dono": "Owner",
    "Registro": "Record",
    "Evidência": "Evidence",
    "Risco": "Risk",
    "Entrada": "Intake",

    // TechStack lane labels
    "LLMs e voz variam por SLA, custo, idioma e risco.":
        "LLMs and voice vary by SLA, cost, language and risk.",
    "Entrada e resposta": "Input and response",
    "Canais": "Channels",

    // ProofResults rows
    "Atendimento e CX": "Service and CX",
    "tempo de resposta, handoff, qualidade, motivo": "response time, handoff, quality, reason",
    "Vendas e SDR": "Sales and SDR",
    "Voz": "Voice",
    "Documentos": "Documents",
    "Backoffice": "Back office",
    "fila, bloqueio, dono, ciclo": "queue, block, owner, cycle",
    "Linha de base": "Baseline",
    "O fluxo atual revela volume, tempo, custo, erro e risco antes do piloto.":
        "The current workflow exposes volume, time, cost, error and risk before the pilot.",
    "Meta de piloto": "Pilot target",
    "Fluxo": "Workflow",

    // ProductSuite & Plataforma module kickers (Title Case - CSS uppercases them)
    "Console de operação": "Operations console",
    "Atendimento conversacional": "Conversational service",
    "GPT interno seguro": "Secure internal GPT",
    "Telefonia governada": "Governed telephony",
    "Documentos e intake": "Documents and intake",
    "Trabalho de retaguarda": "Back-office work",
    "Desempenho operacional": "Operational performance",
    "Treinamento e simulação": "Training and simulation",

    // Plataforma module feature lists
    "Caixas unificadas por fila e operação": "Unified inboxes by queue and operation",
    "Macros e respostas guiadas por política": "Policy-guided macros and replies",
    "Validação humana com SLA por canal": "Human validation with per-channel SLA",
    "Pacote de evidências por conversa": "Evidence package per conversation",
    "Ambiente seguro para uso interno de IA": "Secure environment for internal AI use",
    "Informação estratégica com contexto": "Strategic information with context",
    "Acesso por papel e base autorizada": "Access by role and authorized source",
    "Recepção, callback e discador": "Reception, callback and dialer",
    "Transcrição e scoring em tempo real": "Real-time transcription and scoring",
    "Compatível com Twilio, Aircall, Vonage": "Works with Twilio, Aircall and Vonage",
    "Tags por compliance e por critério": "Tags by compliance and criterion",
    "OCR e extração estruturada": "OCR and structured extraction",
    "Validação contra política": "Policy validation",
    "Roteamento por exceção": "Exception routing",
    "Tarefas com responsável e SLA": "Tasks with owner and SLA",
    "Atualização de CRM por agente": "Agent-driven CRM updates",
    "Follow-up automatizado e revisável": "Automated, reviewable follow-up",
    "Scorecards por papel e fila": "Scorecards by role and queue",
    "Comparativo humano x agente": "Human vs. agent comparison",
    "Detecção de tendência por trend": "Trend-based anomaly detection",
    "Roleplay por persona": "Roleplay by persona",
    "Plano individual por agente humano e IA": "Individual plan per human and AI agent",

    // Plataforma module long descriptions
    "Agentes em WhatsApp, e-mail e canais privados, com contexto unificado e validação humana sob política.":
        "Agents on WhatsApp, email and private channels, with unified context and human validation under policy.",
    "Copiloto corporativo para colaboradores consultarem informações estratégicas, documentos e agentes em um ambiente governado.":
        "A corporate copilot so employees can consult strategic information, documents and agents in a governed environment.",
    "Recepção, callback e prospecção por voz com transcrição, scoring em tempo real e revisão por monitoria.":
        "Reception, callback and voice prospecting with transcription, real-time scoring and monitoring review.",
    "Leitura assistida de contratos, PDFs e formulários, com extração estruturada e fila de exceção.":
        "Assisted reading of contracts, PDFs and forms, with structured extraction and an exception queue.",
    "Cobrança, follow-up, atualização de CRM e tarefas internas executadas por agentes com responsável humano por exceção.":
        "Collections, follow-up, CRM updates and internal tasks executed by agents with a human owner per exception.",
    "Painéis por papel, fila, canal e operação para comparar humano e agente e detectar queda de qualidade cedo.":
        "Dashboards by role, queue, channel and operation to compare human and agent work and catch quality drops early.",
    "Cenários, conversas simuladas, avaliação por critério e planos de coaching individuais.":
        "Scenarios, simulated conversations, criteria-based evaluation and individual coaching plans.",

    // Plataforma lanes (Channels / Knowledge / Improvement)
    "Conhecimento": "Knowledge",
    "Melhoria": "Improvement",
    "Cliente entra por atendimento ou voz": "Customers come in through service or voice",
    "Resultado volta para o ciclo": "Outcomes return to the cycle",
    "Assist e Voice absorvem a linha de frente, mantendo fila, contexto e handoff humano sob a mesma política.":
        "Assist and Voice take the front line, keeping queue, context and human handoff under one policy.",
    "Chat e Tasks conectam perguntas internas, documentos e próximos passos em um ambiente controlado.":
        "Chat and Tasks connect internal questions, documents and next steps in a controlled environment.",
    "Insight mede por papel e canal; Coach transforma evidência em treino para agentes humanos e de IA.":
        "Insight measures by role and channel; Coach turns evidence into training for human and AI agents.",
    "WhatsApp · E-mail · Voz": "WhatsApp · Email · Voice",
    "GPT interno · Base autorizada · Documentos · Tarefas": "Internal GPT · Authorized source · Documents · Tasks",
    "Scorecard · QA · Coaching · Plano": "Scorecard · QA · Coaching · Plan",

    // Plataforma governance bullets
    "RBAC por papel": "RBAC by role",
    "Política antes da ação": "Policy before action",
    "Modelos e quotas": "Models and quotas",
    "Auditoria por turno": "Audit by turn",

    // Plataforma flow steps
    "Governança": "Governance",
    "Execução": "Execution",
    "canal, documento, tarefa": "channel, document, task",
    "papel, política, limite": "role, policy, limit",
    "agente, ferramenta, handoff": "agent, tool, handoff",

    // More PT remnants caught by deeper crawl
    "papel, dado, SLA, risco": "role, data, SLA, risk",
    "Handoff para vendas": "Handoff to sales",
    "Contas entram por valor, atraso, risco, segmento ou oportunidade.":
        "Accounts come in by value, delay, risk, segment or opportunity.",
    "Ciclo fechado": "Closed cycle",
    "backoffice roda no improviso": "back office runs ad-hoc",
    "Rotina recorrente": "Recurring routine",
    "Agente executa": "Agent executes",
    "QA cobre pouco e aprende tarde": "QA covers too little and learns too late",
    "Revisar fronteiras": "Review boundaries",
    "dono": "owner",
    "risco": "risk",
    "Documentos e backoffice": "Documents and back office",
    "Modelos e provedores": "Models and providers",
    "Fila e contexto": "Queue and context",
    "Contexto autorizado": "Authorized context",
    "Uso governado": "Governed use",
    "GPT interno": "Internal GPT",
    "Base autorizada": "Authorized source",
    "Telefonia": "Telephony",
    "Intake documental": "Document intake",
    "Agente": "Agent",
    "Fila viva": "Live queue",
    "Outros fluxos operacionais": "Other operational workflows",
    "Melhoria fechada": "Closed improvement",
    "Escala": "Scale",
    "Roteamento seguro": "Safe routing",
    "Fila unificada": "Unified queue",
    "Fila": "Queue",

    // More site-pages and component labels
    "Controle comum": "Common control",
    "Produto": "Product",
    "Fechamento operacional": "Operational closing",
    "Comum": "Common",
    "Chamada recebida": "Incoming call",
    "Mapeamento": "Mapping",
    "Triagem · Agenda · Privacidade · Follow-up": "Triage · Scheduling · Privacy · Follow-up",
    "Brasil corporativo": "Corporate Brazil",
    "alto sinal": "high signal",
    "bloqueio comum": "common block",
    "Workflow real": "Real workflow",
    "Desenho": "Design",
    "Colaboradores": "Employees",
    "Custo": "Cost",
    "Ajuste": "Adjustment",
    "Triagem": "Triage",
    "Contato ativo": "Active outreach",
    "Pedido em movimento": "Order in motion",

    // Pricing matrix: activity row labels
    "Por mensagem do WhatsApp": "Per WhatsApp message",
    "Por e-mail": "Per email",
    "Por minuto de transcrição de áudio em tempo real (Speech to Text)":
        "Per minute of real-time audio transcription (Speech to Text)",
    "Por minuto gerado para responder por áudio (Text to Speech)":
        "Per minute of audio reply generated (Text to Speech)",
    "Por minuto de ligação": "Per call minute",
    "Por critério avaliado em um checklist": "Per criterion evaluated on a checklist",
    "Por hora de transcrição de áudio em batch (Speech to Text)":
        "Per hour of batch audio transcription (Speech to Text)",
    "Por mensagem": "Per message",
    "Por processamento OCR por página": "Per OCR processing per page",
    "Por critério avaliado em um checklist em uma página":
        "Per criterion evaluated on a checklist per page",
    "Por minuto de treinamento": "Per training minute",
    "Por mensagem executada": "Per executed message",
    "Por gigabyte de armazenamento (imagens, voz, vídeos, arquivos)":
        "Per gigabyte of storage (images, voice, video, files)",
    "Por chamada de tools (chamadas de API, execuções de queries SQL)":
        "Per tool call (API calls, SQL query executions)",
    "atividade": "activity",
    "Sob consulta": "Talk to sales",

    // Pricing hero supporting copy
    "Escolha a reserva de créditos de acordo com a sua necessidade. Quanto maior a reserva, maior o desconto por unidade de atividade de IA.":
        "Choose the credit reserve that fits your needs. The bigger the reserve, the bigger the discount per AI activity unit.",
    "Assinatura em créditos consumíveis": "Subscription in consumable credits",
    "Os créditos são usados por atividades que um agente executa, como responder mensagens, processar documentos ou operar minutos de ligação.":
        "Credits are spent on activities an agent performs — replying to messages, processing documents or running call minutes.",
    "Como a cobrança funciona": "How billing works",
    "Todos os planos dão acesso a todos os apps da Zild Platform.":
        "All plans include access to every app in the Zild Platform.",
    "A assinatura é composta de créditos consumíveis por atividades de IA.":
        "The subscription is made up of consumable credits for AI activities.",
    "Ao ultrapassar o limite mensal, a operação pode seguir em pay-as-you-go ou bloquear uso até a renovação.":
        "Once the monthly limit is reached, the operation can continue pay-as-you-go or block usage until renewal.",
    "Gostaria de uma demonstração sem compromisso?": "Want a no-commitment demo?",
    "Entre em contato para entender o plano, a camada de consumo e a operação inicial mais adequada.":
        "Get in touch to find the right plan, consumption tier and starting operation for you.",
    "Agendar demonstração": "Book a demo",
    "em breve": "coming soon",
    "Estamos preparando um modelo por consumo para equipes que querem começar menor, medir uso real e ajustar a operação conforme a demanda.":
        "We are preparing a usage-based model for teams that want to start smaller, measure real usage and adjust operations as demand changes.",
    "Lista de interesse": "Interest list",
    "Receba novidades assim que esse modelo abrir.": "Receive updates as soon as this model opens.",
    "Avise-me quando abrir": "Notify me when it opens",
    "Receba aviso quando o pay-as-you-go abrir": "Get notified when pay-as-you-go opens",
    "Quero ser avisado": "Notify me",
    "Interesse registrado.": "Interest registered.",
    "Avisaremos pelo e-mail informado assim que o modelo pay-as-you-go estiver disponível.":
        "We will notify the email provided as soon as the pay-as-you-go model is available.",
    "Interesse em pricing": "Pricing interest",
    "Vamos registrar essa escolha no payload para avisar quando o modelo estiver disponível.":
        "We will record this choice in the payload to notify you when the model is available.",
    "pricing · pay as you go": "pricing · pay as you go",

    // Plan fit copy
    "Ideal para começar com automação básica no WhatsApp":
        "Ideal to start with basic WhatsApp automation",
    "Para equipes em crescimento que precisam escalar o atendimento":
        "For growing teams that need to scale customer service",
    "Automação avançada com integrações e maior controle":
        "Advanced automation with integrations and tighter control",
    "Solução corporativa com segurança, SLA e personalização":
        "Enterprise-grade security, SLA and customization",

    "Falar com o comercial": "Talk to sales",
    "plano": "plan",
    "escala": "scale",
    "controle": "control",
    "Ferramentas gerais": "General tools",
    "Suporte e CX em escala": "Customer support and CX at scale",
    "Intake assistido": "Assisted intake",
    "Workflows internos": "Internal workflows",
    "valor acima do limite configurado": "value above the configured limit",
    "Plataforma neutra de modelo,": "Model-neutral platform,",
    "conectada ao trabalho real.": "connected to real work.",
    "ESCALA": "SCALE",
    "CONTROLE": "CONTROL",
    "Falar com o comercial": "Talk to sales",
    "Todos os planos dão acesso a todos os apps da Zild Platform.":
        "All plans include access to every Zild Platform app.",
    "A assinatura é composta de créditos consumíveis por atividades de IA.":
        "The subscription is composed of consumable credits for AI activities.",
    "ATIVIDADE": "ACTIVITY",
    "Por mensagem do WhatsApp": "Per WhatsApp message",
    "Por início de conversa de Utilidade no WhatsApp": "Per WhatsApp utility conversation start",
    "Por início de conversa de Marketing no WhatsApp": "Per WhatsApp marketing conversation start",
    "Por minuto de transcrição de áudio em tempo real (Speech to Text)":
        "Per real-time audio transcription minute (Speech to Text)",
    "Por minuto gerado para responder por áudio (Text to Speech)":
        "Per generated audio response minute (Text to Speech)",
    "Por critério avaliado em um checklist": "Per criterion evaluated in a checklist",
    "Por hora de transcrição de áudio em batch (Speech to Text)":
        "Per batch audio transcription hour (Speech to Text)",
    "Por mensagem": "Per message",
    "Por processamento OCR por página": "Per OCR page processed",
    "Por critério avaliado em um checklist em uma página":
        "Per criterion evaluated in a checklist on one page",
    "Por minuto de treinamento": "Per training minute",
    "Por mensagem executada": "Per executed message",
    "Por gigabyte de armazenamento (imagens, voz, vídeos, arquivos)":
        "Per gigabyte of storage (images, voice, videos, files)",
    "Por chamada de tools (chamadas de API, execuções de queries SQL)":
        "Per tool call (API calls, SQL query executions)",

    "Veja Zild aplicada ao seu primeiro fluxo de IA.":
        "See Zild applied to your first AI workflow.",
    "Próximo passo claro": "Clear next step",
    "Agende uma conversa": "Book a conversation",
    "Nome completo": "Full name",
    "E-mail corporativo": "Work email",
    "Empresa": "Company",
    "Cargo": "Role",
    "Mensagem (opcional)": "Message (optional)",
    "SUAS INFORMAÇÕES SÃO TRATADAS CONFORME A LGPD. NÃO COMPARTILHAMOS COM TERCEIROS.":
        "YOUR INFORMATION IS HANDLED UNDER LGPD. WE DO NOT SHARE IT WITH THIRD PARTIES.",
    "Checklist · governança": "Checklist · governance",
    "Registro contínuo": "Continuous record",
    "Critério de decisão operacional": "Operational decision criterion",
    "Critérios": "Criteria",
    "próximo passo": "next step",
    "Próximo passo": "Next step",
    "handoff visível": "visible handoff",
    "próximo passo fechado": "closed next step",
    "fluxo": "workflow",
    "fluxos": "workflows",
    "fila com volume, SLA e repetição": "queue with volume, SLA and repetition",
    "lead entra e follow-up se perde": "lead enters and follow-up gets lost",
    "carteira exige contato ativo": "portfolio requires active outreach",
    "documento vira retrabalho": "document becomes rework",
    "fluxo crítico não cabe em categoria": "critical workflow does not fit a category",
    "Status · Exceção · Parceiros · SLA": "Status · Exception · Partners · SLA",
    "Fila · SLA · Retenção · Coaching": "Queue · SLA · Retention · Coaching",
    "plano": "plan",
    "escala": "scale",
    "controle": "control",
    "atividade": "activity",
    "Fale com a Zild agora": "Talk to Zild now",
    "Suas informações são tratadas conforme a LGPD.": "Your information is handled under LGPD.",
    "Não compartilhamos com terceiros.": "We do not share it with third parties.",
    "Suas informações são tratadas conforme a LGPD. Não compartilhamos com terceiros.":
        "Your information is handled under LGPD. We do not share it with third parties.",
    "Caso do setor": "Industry case",
    "Recorte de setor": "Industry scope",
    "Fronteira de controle": "Control boundary",
};

Object.assign(EN_US_TEXT, {
    "MÓDULOS": "MODULES",
    "Visão geral": "Overview",
    "A camada humana para operar agentes de IA com regra, confiança e evidência.":
        "The human layer for operating AI agents with rules, trust and evidence.",

    "Lance um fluxo real antes de escalar o programa.": "Launch one real workflow before scaling the program.",
    "A primeira implantação prova o fluxo, as regras, a validação humana e a evidência usada para decidir o próximo passo.":
        "The first implementation proves the workflow, rules, human validation and evidence used to decide the next step.",
    "IMPLANTAÇÃO": "IMPLEMENTATION",
    "Um lançamento controlado": "A controlled launch",
    "A primeira operação precisa sair pequena o bastante para aprender e concreta o bastante para vender internamente.":
        "The first operation must be small enough to learn from and concrete enough to sell internally.",
    "Escolha fluxo, volume, dono, sistemas, riscos e sinal de sucesso.":
        "Choose workflow, volume, owner, systems, risks and success signal.",
    "Defina ação do agente, política, integrações, handoff, QA e evidência.":
        "Define agent action, policy, integrations, handoff, QA and evidence.",
    "Rode com usuários reais enquanto operadores acompanham exceções e custo.":
        "Run with real users while operators track exceptions and cost.",
    "Use resultados para expandir, mudar política, treinar ou parar o fluxo.":
        "Use results to expand, change policy, train or stop the workflow.",
    "produção": "production",
    "Lance pequeno o bastante para medir e sério o bastante para importar.":
        "Launch small enough to measure and serious enough to matter.",
    "O primeiro fluxo precisa de escopo estreito, responsável claro, critério de revisão e rotina de melhoria desde a primeira semana.":
        "The first workflow needs narrow scope, a clear owner, review criteria and an improvement routine from week one.",
    "PLANO DE LANÇAMENTO": "LAUNCH PLAN",
    "Fluxo, política, integração e dono definidos.": "Workflow, policy, integration and owner defined.",
    "Revisão de exceções e qualidade do agente.": "Review of exceptions and agent quality.",
    "Decisão de ajustar, pausar ou ampliar.": "Decision to adjust, pause or expand.",

    "Escolha o primeiro fluxo de IA com critério operacional.":
        "Choose the first AI workflow with operational criteria.",
    "Um bom piloto começa onde há volume, dono, risco controlável e evidência suficiente para decidir se o fluxo deve expandir.":
        "A good pilot starts where there is volume, ownership, controllable risk and enough evidence to decide whether the workflow should expand.",
    "Fazer diagnóstico com Zild": "Run a diagnostic with Zild",
    "Critério de entrada": "Entry criteria",
    "DONO": "OWNER",
    "RISCO": "RISK",
    "EVIDÊNCIA": "EVIDENCE",
    "O objetivo não é escolher a automação mais bonita.":
        "The goal is not to choose the most attractive automation.",
    "É encontrar o fluxo que pode entrar em produção com fronteira, dono e aprendizado suficientes.":
        "It is to find the workflow that can enter production with enough boundary, ownership and learning.",
    "ALTO SINAL": "HIGH SIGNAL",
    "O fluxo acontece toda semana?": "Does the workflow happen every week?",
    "Conversas, chamadas, documentos ou tarefas recorrentes geram aprendizado rápido e medição confiável.":
        "Conversations, calls, documents or recurring tasks create fast learning and reliable measurement.",
    "Existe uma pessoa responsável?": "Is there an accountable person?",
    "Um agente só entra em produção quando alguém pode definir regra, aceitar risco e revisar exceções.":
        "An agent only enters production when someone can define rules, accept risk and review exceptions.",
    "A decisão tem limite claro?": "Does the decision have a clear boundary?",
    "PROVA": "PROOF",
    "Entrada, resposta, motivo de handoff, custo, SLA, nota de qualidade e próxima ação devem ficar juntos.":
        "Input, response, handoff reason, cost, SLA, quality score and next action must stay together.",
    "COMEÇAR POR UM FLUXO": "START WITH ONE WORKFLOW",
    "O diagnóstico melhora quando já entra com operação, canal, volume e risco aproximados.":
        "The diagnostic improves when it starts with operation, channel, volume and approximate risk.",
    "Atendimento e SAC": "Support and customer service",
    "Fila com volume, SLA, handoff humano e evidência de resolução.":
        "Queue with volume, SLA, human handoff and resolution evidence.",
    "Lead que precisa de qualificação, follow-up e próximo passo claro.":
        "Lead that needs qualification, follow-up and a clear next step.",
    "OPERAÇÃO": "OPERATION",
    "Intake, conferência, exceção e tarefa de retorno com trilha auditável.":
        "Intake, checking, exception and return task with an auditable trail.",
    "Levar para contato": "Take to contact",

    "IA para atendimento por WhatsApp, SAC e canais digitais.":
        "AI for WhatsApp, support and digital service channels.",
    "IA SDR para qualificar, fazer follow-up e manter evidência no CRM.":
        "AI SDR to qualify, follow up and keep evidence in the CRM.",
    "IA para outbound, cobrança e follow-up ativo.":
        "AI for outbound, collections and active follow-up.",
    "IA para voz, recepção e transferência com contexto.":
        "AI for voice, reception and transfer with context.",
    "IA para monitoria de qualidade em conversas e chamadas.":
        "AI for quality monitoring in conversations and calls.",
    "IA para documentos, intake e revisão humana.":
        "AI for documents, intake and human review.",
    "IA para backoffice e rotinas internas com dono.":
        "AI for back office and owned internal routines.",
    "Diagnosticar este fluxo": "Diagnose this workflow",
    "Reduzir fila sem esconder risco de atendimento.": "Reduce queues without hiding service risk.",
    "Do contato inicial ao registro de qualidade.": "From initial contact to quality record.",
    "Traga uma fila real de WhatsApp, SAC ou canal digital para desenharmos o primeiro fluxo.":
        "Bring a real WhatsApp, support or digital-channel queue so we can design the first workflow.",
    "Validação humana": "Human validation",
    "BLUEPRINT DO FLUXO": "WORKFLOW BLUEPRINT",
    "Volume, SLA, assunto e cliente sensível aparecem antes da resposta.":
        "Volume, SLA, subject and sensitive customer appear before the response.",
    "Resolução segura": "Safe resolution",
    "O agente só resolve o que a política permite e deixa resumo quando para.":
        "The agent only resolves what policy allows and leaves a summary when it stops.",
    "Amostras, transferências e motivos alimentam monitoria sem depender de planilha.":
        "Samples, transfers and reasons feed monitoring without depending on spreadsheets.",
    "SLA pressionado, cliente crítico, baixa confiança e risco de política definem quando uma pessoa assume.":
        "Pressured SLA, critical customer, low confidence and policy risk define when a person takes over.",
    "Quando a pessoa entra": "When a person steps in",
    "O handoff não é tratado como falha. Ele carrega motivo, contexto, responsável e próxima ação.":
        "The handoff is not treated as a failure. It carries reason, context, owner and next action.",
    "Fluxos próximos que costumam aparecer na mesma conversa.":
        "Adjacent workflows that usually appear in the same conversation.",
    "PILOTO DO FLUXO": "WORKFLOW PILOT",
    "Transforme este fluxo em uma operação mensurável.":
        "Turn this workflow into a measurable operation.",
    "Levamos uma fila, carteira, chamada ou rotina para um desenho de entrada, política, handoff e evidência antes do go-live.":
        "We turn a queue, portfolio, call or routine into an intake, policy, handoff and evidence design before go-live.",
    "SESSÃO DE DESENHO": "DESIGN SESSION",
    "Qual decisão pode ser automatizada e qual precisa de pessoa.":
        "Which decision can be automated and which needs a person.",
    "Medição": "Measurement",
    "Volume, SLA, custo e qualidade para provar valor.":
        "Volume, SLA, cost and quality to prove value.",
    "Qualificar com cadência, contexto e handoff comercial claro.":
        "Qualify with cadence, context and clear sales handoff.",
    "Da entrada do lead à próxima ação no CRM.": "From lead intake to the next action in the CRM.",
    "Traga o critério de qualificação e uma etapa do CRM que hoje fica desatualizada.":
        "Bring the qualification criteria and one CRM stage that gets stale today.",
    "Lead, conta ou carteira entram com valor, origem, risco e próxima tentativa.":
        "Lead, account or portfolio enters with value, source, risk and next attempt.",
    "Cadência governada": "Governed cadence",
    "Mensagem, voz e follow-up respeitam janela, tom, política e etapa comercial.":
        "Message, voice and follow-up respect window, tone, policy and sales stage.",
    "CRM como prova": "CRM as proof",
    "Resultado, objeção, responsável e próxima ação ficam registrados.":
        "Outcome, objection, owner and next action stay recorded.",
    "Fit, urgência, objeção, etapa e valor potencial decidem o que o agente conduz e o que vai para vendas.":
        "Fit, urgency, objection, stage and potential value decide what the agent handles and what goes to sales.",
    "Rodar contato ativo com política, janela e próximo passo.":
        "Run active outreach with policy, window and next step.",
    "Da priorização da carteira ao fechamento da tentativa.":
        "From portfolio prioritization to closing the attempt.",
    "Traga uma carteira, regra de contato e o motivo que hoje quebra a cadência.":
        "Bring a portfolio, contact rule and the reason cadence breaks today.",
    "Cobrança": "Collections",
    "Promessa, contestação, cobrança sensível, janela de contato e baixa confiança passam para humano.":
        "Promise, dispute, sensitive collection, contact window and low confidence go to a human.",
    "Da chamada recebida à transcrição revisável.": "From incoming call to reviewable transcript.",
    "Traga os principais motivos de ligação e o que precisa chegar pronto para quem atende.":
        "Bring the main call reasons and what must arrive ready for the person who answers.",
    "Recepção": "Reception",
    "Transferência": "Transfer",
    "Intenção, identidade, urgência, área responsável e risco de resposta definem rota ou transferência.":
        "Intent, identity, urgency, responsible team and response risk define route or transfer.",
    "Transformar conversas e chamadas em critério, evidência e melhoria.":
        "Turn conversations and calls into criteria, evidence and improvement.",
    "Da amostra operacional ao ajuste de política ou coaching.":
        "From operational sample to policy adjustment or coaching.",
    "Traga um scorecard ou alguns atendimentos recentes para separarmos critério de opinião.":
        "Bring a scorecard or recent service examples so we can separate criteria from opinion.",
    "Tendência": "Trend",
    "Amostra contínua": "Continuous sample",
    "Conversas e chamadas entram por fila, canal, pessoa, agente e critério.":
        "Conversations and calls enter by queue, channel, person, agent and criterion.",
    "Score explicável": "Explainable score",
    "Cada nota precisa apontar evidência, trecho e regra de avaliação.":
        "Each score must point to evidence, excerpt and evaluation rule.",
    "Tendência vira ajuste de política, coaching ou parada do fluxo.":
        "Trend becomes policy adjustment, coaching or workflow stop.",
    "Critério de qualidade, risco, tom, resolução e aderência mostram onde revisar agente, humano ou processo.":
        "Quality criteria, risk, tone, resolution and adherence show where to review agent, human or process.",
    "Extrair, conferir e encaminhar documentos com exceção visível.":
        "Extract, check and route documents with visible exceptions.",
    "Do arquivo recebido à tarefa de follow-up.": "From received file to follow-up task.",
    "Traga um tipo de documento e a checklist que hoje depende de conferência manual.":
        "Bring a document type and the checklist that depends on manual checking today.",
    "Revisão": "Review",
    "Documento, tarefa ou pedido chega com tipo, dono, prazo e dados esperados.":
        "Document, task or request arrives with type, owner, deadline and expected data.",
    "Exceção visível": "Visible exception",
    "Campo ausente, bloqueio ou baixa confiança vai para uma pessoa com contexto.":
        "Missing field, block or low confidence goes to a person with context.",
    "Sistema atualizado, tarefa aberta e evidência pronta para revisão.":
        "System updated, task opened and evidence ready for review.",
    "Campo ausente, confiança baixa, divergência e risco de decisão acionam revisão humana antes de seguir.":
        "Missing field, low confidence, discrepancy and decision risk trigger human review before continuing.",
    "Tirar rotina recorrente da cabeça do time e colocar dono em cada exceção.":
        "Take recurring routines out of the team's head and put an owner on each exception.",
    "Da tarefa repetida ao registro de produtividade.": "From repeated task to productivity record.",
    "Traga uma rotina interna que consome tempo toda semana e ainda não tem trilha confiável.":
        "Bring an internal routine that consumes time every week and still lacks a reliable trail.",
    "Bloqueio, sistema sem dado, decisão sensível e prazo pressionado chegam ao responsável com contexto.":
        "Block, missing system data, sensitive decision and pressured deadline reach the owner with context.",
    "MÓDULOS COMBINADOS": "COMBINED MODULES",
    "Do mapeamento ao próximo fluxo escalável.": "From mapping to the next scalable workflow.",
    "Traga o fluxo que parece valioso, mas ainda não tem fronteira operacional clara.":
        "Bring the workflow that seems valuable but does not yet have a clear operational boundary.",
    "Validação": "Validation",
    "Módulos combinados": "Combined modules",
    "Um fluxo real, uma fronteira clara e um responsável pelo primeiro ciclo.":
        "One real workflow, one clear boundary and one owner for the first cycle.",
    "Piloto medível": "Measurable pilot",
    "Volume, custo, qualidade e risco definem se a versão deve seguir.":
        "Volume, cost, quality and risk define whether the version should continue.",
    "Escala por prova": "Scale by proof",
    "A expansão depende de evidências, não de entusiasmo com automação.":
        "Expansion depends on evidence, not enthusiasm for automation.",
    "Volume, sistemas, donos, risco, validação e métrica de sucesso definem o tamanho do primeiro piloto.":
        "Volume, systems, owners, risk, validation and success metric define the size of the first pilot.",

    "Console para agentes, papéis, permissões, modelos, cotas, políticas e auditoria em uma camada comum.":
        "Console for agents, roles, permissions, models, quotas, policies and audit in one common layer.",
    "Times definem quem pode agir, em qual operação, com quais dados e limites.":
        "Teams define who can act, in which operation, with which data and limits.",
    "A operação acompanha modelos conectados, consumo, cotas e decisões de troca.":
        "The operation tracks connected models, usage, quotas and switching decisions.",
    "Cada turno mantém trilha de ação, validação, responsável, custo e evidência.":
        "Each turn keeps a trail of action, validation, owner, cost and evidence.",
    "Evidência que fica": "Evidence that remains",
    "Políticas": "Policies",
    "VER PÁGINA": "VIEW PAGE",
    "Agentes em WhatsApp, e-mail e canais privados com contexto unificado e validação humana sob política.":
        "Agents on WhatsApp, email and private channels with unified context and human validation under policy.",
    "Ação segura": "Safe action",
    "Conversas chegam com cliente, histórico, canal, SLA e operação visíveis.":
        "Conversations arrive with visible customer, history, channel, SLA and operation.",
    "O agente resolve o que está dentro da política e prepara o que precisa de confirmação.":
        "The agent resolves what is inside policy and prepares what needs confirmation.",
    "Risco, baixa confiança ou cliente crítico passam para uma pessoa com resumo e evidência.":
        "Risk, low confidence or critical customer go to a person with summary and evidence.",
    "GPT interno seguro para colaboradores usarem IA com informações estratégicas da empresa, bases autorizadas e governança.":
        "Secure internal GPT for employees to use AI with company strategic information, authorized sources and governance.",
    "Colaboradores conversam com IA em um ambiente corporativo, conectado ao contexto que a empresa permite usar.":
        "Employees talk to AI in a corporate environment connected to context the company allows.",
    "Respostas partem de bases, documentos, agentes e políticas liberados para cada papel.":
        "Answers come from sources, documents, agents and policies authorized for each role.",
    "Histórico, escopo, permissão e evidência ajudam a revisar como a IA é usada dentro da operação.":
        "History, scope, permission and evidence help review how AI is used inside the operation.",
    "Recepção, callback, prospecção e cobrança por voz com transcrição, scoring e revisão operacional.":
        "Reception, callback, prospecting and collections by voice with transcription, scoring and operational review.",
    "Entrada telefônica": "Phone intake",
    "Voz com política": "Voice with policy",
    "Registro revisável": "Reviewable record",
    "Chamadas são atendidas, classificadas e roteadas com intenção e contexto.":
        "Calls are answered, classified and routed with intent and context.",
    "Scripts, limites, transferências e critérios de risco ficam explícitos.":
        "Scripts, limits, transfers and risk criteria are explicit.",
    "Transcrição, resultado, transferência e nota de qualidade seguem para Insight.":
        "Transcript, outcome, transfer and quality score go to Insight.",
    "Transcrição": "Transcript",
    "Painéis para medir agentes, humanos, filas, canais, custos, qualidade e tendências de operação.":
        "Dashboards to measure agents, humans, queues, channels, costs, quality and operational trends.",
    "Score por critério": "Score by criterion",
    "Tendência operacional": "Operational trend",
    "Decisão de melhoria": "Improvement decision",
    "Conversas, chamadas e tarefas são avaliadas contra critérios definidos pelo time.":
        "Conversations, calls and tasks are evaluated against criteria defined by the team.",
    "Líderes enxergam queda de qualidade, recorrência de assunto e pontos de risco.":
        "Leaders see quality drops, recurring subjects and risk points.",
    "A evidência vira ajuste de política, coaching, automação ou parada do fluxo.":
        "Evidence becomes policy adjustment, coaching, automation or workflow stop.",
    "Entrada documental com OCR, extração estruturada, validação contra política e fila de exceção.":
        "Document intake with OCR, structured extraction, policy validation and exception queue.",
    "Extração com limite": "Extraction with boundary",
    "Contratos, PDFs e formulários entram com tipo, origem e campos esperados.":
        "Contracts, PDFs and forms enter with type, source and expected fields.",
    "Campos são extraídos, comparados com política e marcados por confiança.":
        "Fields are extracted, compared with policy and marked by confidence.",
    "Documento incompleto, baixa confiança ou risco vai para uma pessoa com contexto.":
        "Incomplete document, low confidence or risk goes to a person with context.",
    "Exceções": "Exceptions",
    "Gerencie tarefas associadas a pessoas ou agentes de IA com uma visualização clara da execução de processos.":
        "Manage tasks assigned to people or AI agents with a clear view of process execution.",
    "Processos em uma só visão": "Processes in one view",
    "Acompanhe etapas, responsáveis, prazos e dependências ao longo de cada execução.":
        "Track stages, owners, deadlines and dependencies throughout each execution.",
    "Humanos e agentes de IA": "People and AI agents",
    "Distribua tarefas entre pessoas e agentes, mantendo handoffs, exceções e contexto visíveis.":
        "Assign tasks to people and agents while keeping handoffs, exceptions and context visible.",
    "Execução rastreável": "Traceable execution",
    "Monitore o andamento do processo, identifique bloqueios e preserve o histórico de cada ação.":
        "Monitor process progress, identify blockers and preserve the history of every action.",
    "Processos": "Processes",
    "Tarefas": "Tasks",
    "Pessoas": "People",
    "Agentes de IA": "AI agents",
    "Treinamento, simulação, avaliação por critério e planos de coaching para agentes humanos e de IA.":
        "Training, simulation, criteria-based evaluation and coaching plans for human and AI agents.",
    "Cenários reais": "Real scenarios",
    "Avaliação por critério": "Criteria-based evaluation",
    "Plano de melhoria": "Improvement plan",
    "Casos recorrentes viram simulações com persona, regra, risco e resposta esperada.":
        "Recurring cases become simulations with persona, rule, risk and expected response.",
    "O time mede aderência à política, tom, resolução e handoff.":
        "The team measures policy adherence, tone, resolution and handoff.",
    "Evidência do Insight alimenta coaching, treinamento e revisão de agente.":
        "Insight evidence feeds coaching, training and agent review.",

    "TRIAGEM · AGENDA · PRIVACIDADE · FOLLOW-UP": "TRIAGE · SCHEDULING · PRIVACY · FOLLOW-UP",
    "IA para operações de saúde com controle de atendimento.":
        "AI for healthcare operations with service control.",
    "SETOR EM PRODUÇÃO": "INDUSTRY IN PRODUCTION",
    "Do trabalho real ao registro revisável.": "From real work to reviewable record.",
    "Registro e retorno": "Record and follow-up",
    "Pedidos chegam por WhatsApp, telefone ou formulário com contexto clínico-operacional.":
        "Requests arrive through WhatsApp, phone or form with clinical-operational context.",
    "O agente separa dúvidas administrativas de casos que exigem equipe responsável.":
        "The agent separates administrative questions from cases that require the responsible team.",
    "Confirmação, documento pendente, agendamento e follow-up ficam rastreáveis.":
        "Confirmation, pending document, scheduling and follow-up remain traceable.",
    "Outros setores": "Other industries",
    "IA para serviços financeiros com política e evidência.":
        "AI for financial services with policy and evidence.",
    "A operação usa perfil, histórico, produto e política para orientar a ação.":
        "The operation uses profile, history, product and policy to guide action.",
    "Cobrança e follow-up seguem tom, janela, política e evidência.":
        "Collections and follow-up follow tone, window, policy and evidence.",
    "Decisões, exceções e resultados permanecem revisáveis por compliance e liderança.":
        "Decisions, exceptions and outcomes remain reviewable by compliance and leadership.",
    "IA para logística, status, exceções e comunicação operacional.":
        "AI for logistics, status, exceptions and operational communication.",
    "Exceção operacional": "Operational exception",
    "Comunicação contínua": "Continuous communication",
    "Exceção": "Exception",
    "O agente consulta status, rota, prazo, documento e histórico de contato.":
        "The agent checks status, route, deadline, document and contact history.",
    "Atraso, avaria, divergência ou cliente crítico vira tarefa com responsável.":
        "Delay, damage, discrepancy or critical customer becomes an owned task.",
    "Cliente, operação e parceiro recebem atualização com registro comum.":
        "Customer, operation and partner receive updates with a common record.",
    "IA para operações de cliente com SLA, fila e qualidade.":
        "AI for customer operations with SLA, queue and quality.",
    "Melhoria contínua": "Continuous improvement",
    "Retenção": "Retention",
    "Canais, prioridade, cliente e SLA aparecem como uma operação, não como caixas soltas.":
        "Channels, priority, customer and SLA appear as one operation, not loose inboxes.",
    "Casos sensíveis passam para pessoas com contexto e trilha clara.":
        "Sensitive cases go to people with context and a clear trail.",
    "Insight e Coach transformam evidência em ajuste de equipe, política e agente.":
        "Insight and Coach turn evidence into team, policy and agent adjustments.",

    "A camada humana para empresas que levam IA para produção.":
        "The human layer for companies taking AI to production.",
    "Zild vem de Zilda, avó da Ana, co-fundadora da Zild. O símbolo vem da marca que uma xícara de café deixa na mesa depois de uma conversa: alguém esteve presente, algo foi decidido e uma evidência ficou para ser revisada.":
        "Zild comes from Zilda, grandmother of Ana, Zild's co-founder. The symbol comes from the mark a cup of coffee leaves on the table after a conversation: someone was present, something was decided and evidence remained for review.",
    "Essa é a tese da Zild: IA só deve operar quando existe contexto humano antes da ação e trilha clara depois da ação.":
        "That is Zild's thesis: AI should operate only when there is human context before action and a clear trail after action.",
    "ORIGEM DO SÍMBOLO": "ORIGIN OF THE SYMBOL",
    "Antes de enviar um agente para produção, entendemos processo, risco, papel e responsabilidade.":
        "Before sending an agent to production, we understand process, risk, role and responsibility.",
    "Agentes ampliam o time. Decisões críticas, exceções e confiança continuam com pessoas responsáveis.":
        "Agents extend the team. Critical decisions, exceptions and trust remain with responsible people.",
    "Evidência por padrão": "Evidence by default",
    "Sem trilha auditável, não há produção. Sem produção, não há valor.":
        "Without an auditable trail, there is no production. Without production, there is no value.",

    "Documentação para tirar um fluxo de IA do slide.":
        "Documentation to take an AI workflow out of the slide deck.",
    "A biblioteca técnica da Zild é organizada ao redor do que precisa estar claro antes de produção: conceito, API, integração, segurança e auditoria.":
        "Zild's technical library is organized around what must be clear before production: concept, API, integration, security and audit.",
    "ARQUITETURA · SEGURANÇA · IMPLANTAÇÃO": "ARCHITECTURE · SECURITY · IMPLEMENTATION",
    "Público": "Audience",
    "conceitos e guias de operação": "concepts and operating guides",
    "arquitetura, segurança e DPA": "architecture, security and DPA",
    "Cliente": "Customer",
    "Comece por política, papel e operação. Só depois avance para APIs, integrações e eventos.":
        "Start with policy, role and operation. Only then move to APIs, integrations and events.",
    "O que é um agente em Zild": "What an agent is in Zild",
    "Política, papel e operação": "Policy, role and operation",
    "Validação humana e handoff": "Human validation and handoff",
    "Trilha de auditoria": "Audit trail",
    "Autenticação e tokens": "Authentication and tokens",
    "Webhooks de operação": "Operational webhooks",
    "Eventos de auditoria": "Audit events",
    "Integrações": "Integrations",
    "Segurança": "Security",
    "Hash de auditoria externo": "External audit hash",

    "Memorandos para colocar agentes de IA em operação.":
        "Memos for putting AI agents into operation.",
    "Leituras curtas para decidir fluxo, fronteira, handoff, evidência e expansão com menos teatro e mais operação real.":
        "Short reads to decide workflow, boundary, handoff, evidence and expansion with less theater and more real operation.",
    "Publicação de campo": "Field publication",
    "IMPLANTAÇÃO · GOVERNANÇA · QUALIDADE": "IMPLEMENTATION · GOVERNANCE · QUALITY",
    "Como escolher o primeiro fluxo para um agente de IA":
        "How to choose the first workflow for an AI agent",
    "Critérios práticos para encontrar volume, risco, validação humana e evidência antes da primeira implantação.":
        "Practical criteria for finding volume, risk, human validation and evidence before the first implementation.",
    "O que registrar quando um agente passa uma conversa para uma pessoa":
        "What to record when an agent hands a conversation to a person",
    "Transcrição, motivo, dono, SLA, custo e nota de qualidade tornam o fluxo auditável.":
        "Transcript, reason, owner, SLA, cost and quality score make the workflow auditable.",
    "Quando automação documental precisa de revisão humana":
        "When document automation needs human review",
    "Baixa confiança, documento incompleto e risco de política são sinais de que o próximo passo precisa de controle.":
        "Low confidence, incomplete document and policy risk are signs that the next step needs control.",

    "Suporte para operações Zild em produção.": "Support for Zild operations in production.",
    "O caminho de suporte depende do impacto operacional. Use e-mail para contexto, WhatsApp para incidente e telefone para escalação rápida.":
        "The support path depends on operational impact. Use email for context, WhatsApp for incidents and phone for fast escalation.",
    "workspace e operação afetada": "affected workspace and operation",
    "canal, fila, horário e prints": "channel, queue, time and screenshots",
    "canal parado ou cliente aguardando": "channel down or customer waiting",
    "degradação de fila, voz ou integração": "queue, voice or integration degradation",
    "ajuste, dúvida ou revisão de configuração": "adjustment, question or configuration review",
    "ASSÍNCRONO": "ASYNCHRONOUS",
    "E-mail de suporte": "Support email",
    "Configuração, contexto técnico e acompanhamentos que não interrompem a operação.":
        "Configuration, technical context and follow-ups that do not interrupt the operation.",
    "Fila travada, canal fora do ar, impacto em atendimento ou operação com cliente aguardando.":
        "Stuck queue, channel outage, service impact or operation with customer waiting.",
    "ESCALAÇÃO": "ESCALATION",
    "Telefone": "Phone",
    "Clientes com contrato ativo e necessidade de coordenação imediata com o time Zild.":
        "Customers with an active contract and need for immediate coordination with the Zild team.",

    "PRIVACIDADE": "PRIVACY",
    "Política de privacidade": "Privacy policy",
    "Como a Zild coleta, usa, armazena, processa e protege dados pessoais e informações relacionadas ao uso da plataforma.":
        "How Zild collects, uses, stores, processes and protects personal data and information related to platform use.",
    "Documento público": "Public document",
    "Última revisão pública: 2026.": "Last public review: 2026.",
    "Contrato e DPA podem trazer termos adicionais.": "Contract and DPA may include additional terms.",
    "Dúvidas devem seguir pelo suporte.": "Questions should go through support.",
    "LGPD e contratos de cliente": "LGPD and customer contracts",
    "plataforma, canais e integrações": "platform, channels and integrations",
    "Dúvidas": "Questions",
    "suporte ou canal contratual": "support or contractual channel",
    "Índice do registro": "Record index",
    "Dados tratados": "Data processed",
    "Podemos tratar dados de identificação, contato profissional, uso da plataforma, integrações, mensagens, áudios, transcrições, logs técnicos e metadados necessários para operação, suporte, segurança e auditoria.":
        "We may process identification data, professional contact data, platform usage, integrations, messages, audio, transcripts, technical logs and metadata needed for operation, support, security and audit.",
    "Os dados são usados para fornecer a plataforma, executar integrações configuradas pelo cliente, monitorar estabilidade, prestar suporte, cumprir obrigações legais e melhorar o serviço.":
        "Data is used to provide the platform, execute customer-configured integrations, monitor stability, provide support, comply with legal obligations and improve the service.",
    "Dados podem ser compartilhados com fornecedores necessários à operação, como nuvem, IA, telecomunicações e mensageria, sempre sob contratos com confidencialidade e proteção de dados.":
        "Data may be shared with providers needed for operation, such as cloud, AI, telecommunications and messaging, always under contracts with confidentiality and data protection.",
    "Adotamos controles técnicos, administrativos e organizacionais, incluindo controle lógico de acesso, criptografia quando aplicável, monitoramento e registros de eventos.":
        "We adopt technical, administrative and organizational controls, including logical access control, encryption when applicable, monitoring and event records.",
    "Titulares podem solicitar confirmação de tratamento, acesso, correção, anonimização, bloqueio, eliminação, portabilidade e informações sobre compartilhamento, conforme a LGPD.":
        "Data subjects may request confirmation of processing, access, correction, anonymization, blocking, deletion, portability and information about sharing, as provided by LGPD.",
    "Solicitações relacionadas a privacidade devem ser enviadas pelos canais de suporte da Zild.":
        "Privacy-related requests should be sent through Zild support channels.",

    "Termos de uso": "Terms of use",
    "Condições gerais para acesso e uso da plataforma Zild por clientes, administradores e usuários autorizados.":
        "General conditions for access and use of the Zild platform by customers, administrators and authorized users.",
    "termos públicos e contrato": "public terms and contract",
    "clientes, admins e usuários": "customers, admins and users",
    "suporte ou comercial": "support or sales",
    "Descrição do serviço": "Service description",
    "Responsabilidade do usuário": "User responsibility",
    "Terceiros": "Third parties",
    "Suporte e SLA": "Support and SLA",
    "Ao acessar a plataforma, o usuário concorda com estes termos e com as regras do contrato aplicável.":
        "By accessing the platform, the user agrees to these terms and the rules of the applicable contract.",
    "A Zild é uma plataforma para orquestração, gestão e operação de agentes de IA, canais de comunicação, integrações, automações, monitoria e fluxos inteligentes.":
        "Zild is a platform for orchestration, management and operation of AI agents, communication channels, integrations, automations, monitoring and intelligent workflows.",
    "A plataforma deve ser usada apenas para fins legais, em conformidade com leis aplicáveis, proteção de dados, regras setoriais e políticas contratadas.":
        "The platform must be used only for legal purposes, in compliance with applicable laws, data protection, sector rules and contracted policies.",
    "O usuário é responsável por credenciais, conteúdo, dados, mensagens e configurações processadas por sua conta ou operação.":
        "The user is responsible for credentials, content, data, messages and settings processed by their account or operation.",
    "A plataforma pode depender de serviços de nuvem, mensageria, telefonia e provedores de IA. Falhas ou mudanças desses terceiros podem afetar funcionalidades.":
        "The platform may depend on cloud, messaging, telephony and AI provider services. Failures or changes from those third parties may affect functionality.",
    "Suporte, disponibilidade, prazos e níveis de serviço seguem o contrato ou plano vigente.":
        "Support, availability, deadlines and service levels follow the active contract or plan.",
    "Estes termos são regidos pelas leis da República Federativa do Brasil.":
        "These terms are governed by the laws of the Federative Republic of Brazil.",
});

Object.assign(EN_US_TEXT, {
    "Limite de dados respeitado": "Data boundary respected",
    "A Zild define o que pode acontecer.": "Zild defines what can happen.",
    "Ambiente seguro para uso interno de IA": "Safe environment for internal AI use",
    "Trabalho de retaguarda": "Back-office work",
    "Pedidos repetidos, follow-ups perdidos e contexto espalhado entre caixas de entrada.":
        "Repeated requests, missed follow-ups and context scattered across inboxes.",
    "Antes da Zild": "Before Zild",
    "Fluxo implantado": "Deployed workflow",
    "Regras de controle": "Control rules",
    "Evidência capturada": "Evidence captured",
    "O agente identifica intenção, consulta contexto, resolve o que é seguro e prepara próximas ações.":
        "The agent identifies intent, checks context, resolves what is safe and prepares next actions.",
    "Baixa confiança, risco de política, SLA pressionado ou cliente crítico passam para uma pessoa.":
        "Low confidence, policy risk, pressured SLA or a critical customer go to a person.",
    "Transcrição, motivo da transferência, responsável, resultado, nota de qualidade e custo ficam juntos.":
        "Transcript, transfer reason, owner, outcome, quality score and cost stay together.",
    "O agente atende, entende motivo, confirma dados e localiza contexto.":
        "The agent answers, understands the reason, confirms data and finds context.",

    "Implantação": "Implementation",
    "IMPLANTAÇÃO": "IMPLEMENTATION",
    "Registro operacional": "Operational record",
    "Diagnóstico": "Diagnostic",
    "Plano de lançamento": "Launch plan",
    "PLANO DE LANÇAMENTO": "LAUNCH PLAN",
    "EVIDÊNCIA": "EVIDENCE",
    "Operação": "Operation",
    "OPERAÇÃO": "OPERATION",
    "O desenho precisa separar o que a IA resolve, o que confirma e o que sempre passa para humano.":
        "The design needs to separate what AI resolves, what it confirms and what always goes to a human.",
    "Começar por um fluxo": "Start with one workflow",
    "COMEÇAR POR UM FLUXO": "START WITH ONE WORKFLOW",
    "Use um caso concreto para a primeira conversa.": "Use a concrete case for the first conversation.",

    "Sete apps, uma camada de operação.": "Seven apps, one operating layer.",
    "Admin define limites. Assist e Voice operam a linha de frente. Chat dá um GPT interno seguro para o time. Tasks transforma registros em ação. Insight e Coach fecham o ciclo de melhoria.":
        "Admin defines limits. Assist and Voice operate the front line. Chat gives the team a secure internal GPT. Tasks turns records into action. Insight and Coach close the improvement cycle.",
    "Desenhar um piloto sob medida sem virar projeto abstrato.":
        "Design a tailored pilot without turning it into an abstract project.",
    "Caminhos de implantação": "Implementation paths",
    "evidência": "evidence",
    "Piloto do fluxo": "Workflow pilot",
    "PILOTO DO FLUXO": "WORKFLOW PILOT",
    "Sessão de desenho": "Design session",
    "SESSÃO DE DESENHO": "DESIGN SESSION",
    "Do problema ao piloto": "From problem to pilot",
    "Onde o trabalho chega hoje e quem sente o atraso.":
        "Where work arrives today and who feels the delay.",

    "Outros apps da plataforma": "Other platform apps",
    "VER PÁGINA": "VIEW PAGE",
    "Copiloto para o time": "Copilot for the team",
    "Handoff humano": "Human handoff",
    "Revisão humana": "Human review",
    "Critério": "Criterion",

    "O que precisamos levar": "What we need to bring",
    "Setor em produção": "Industry in production",
    "SETOR EM PRODUÇÃO": "INDUSTRY IN PRODUCTION",
    "Entrada de paciente": "Patient intake",
    "Contexto de conta": "Account context",
    "Controle humano": "Human control",

    "ORIGEM DO SÍMBOLO": "ORIGIN OF THE SYMBOL",
    "Uma conversa deixa rastro.": "A conversation leaves a trail.",

    "Acesso completo sob NDA": "Full access under NDA",
    "Ordem recomendada": "Recommended order",
    "Conceitos": "Concepts",
    "ARQUITETURA · SEGURANÇA · IMPLANTAÇÃO": "ARCHITECTURE · SECURITY · IMPLEMENTATION",
    "Solicitar acesso": "Request access",
    "Fronteiras de dado": "Data boundaries",
    "Soberania de dado BR/EU": "Data residency BR/EU",
    "IMPLANTAÇÃO · GOVERNANÇA · QUALIDADE": "IMPLEMENTATION · GOVERNANCE · QUALITY",
    "Governança": "Governance",
    "Qualidade": "Quality",

    "ID de conversa, chamada ou tarefa quando existir": "Conversation, call or task ID when available",
    "Assíncrono": "Asynchronous",
    "ASSÍNCRONO": "ASYNCHRONOUS",
    "Escalação": "Escalation",
    "ESCALAÇÃO": "ESCALATION",
    "Dúvidas devem seguir pelo suporte.": "Questions should go through support.",
    "Uso da plataforma": "Platform use",
    "USO DA PLATAFORMA": "PLATFORM USE",

    "O que observar": "What to watch",
    "memo operacional": "operational memo",
    "Leitura para decidir o próximo fluxo, não para colecionar ideias.":
        "A read to decide the next workflow, not collect ideas.",
    "Quer aplicar esse fluxo na sua operação?": "Want to apply this workflow in your operation?",

    "Comece onde o trabalho já acontece": "Start where the work already happens",
    "Procure limite operacional, não só automação": "Look for an operational boundary, not only automation",
    "Exija evidência desde o primeiro dia": "Require evidence from day one",
    "O melhor primeiro fluxo não é o mais chamativo. É o que já tem volume, dono claro e repetição suficiente para medir antes e depois.":
        "The best first workflow is not the flashiest one. It is the one that already has volume, a clear owner and enough repetition to measure before and after.",
    "Em empresas brasileiras, isso costuma aparecer em atendimento por WhatsApp, triagem comercial, recepção por voz, entrada de documentos ou follow-up de exceções internas.":
        "In Brazilian companies, this often appears in WhatsApp support, commercial triage, voice reception, document intake or follow-up on internal exceptions.",
    "Um bom fluxo para agente tem uma fronteira clara: o que a IA pode resolver, quando precisa pedir confirmação e quando o caso deve passar para uma pessoa.":
        "A good agent workflow has a clear boundary: what AI can resolve, when it needs confirmation and when the case must go to a person.",
    "Se essa fronteira ainda não existe, o primeiro trabalho é desenhar política, SLA, risco e dono humano antes de colocar o agente em produção.":
        "If that boundary does not exist yet, the first job is to design policy, SLA, risk and human ownership before putting the agent into production.",
    "Cada execução precisa deixar registro: entrada, resposta, motivo de validação humana, resultado, custo, nota de qualidade e próxima ação.":
        "Each execution needs to leave a record: input, response, human validation reason, outcome, cost, quality score and next action.",
    "Sem evidência, o projeto vira opinião. Com evidência, a operação consegue corrigir, expandir ou parar o fluxo com segurança.":
        "Without evidence, the project becomes opinion. With evidence, the team can safely correct, expand or stop the workflow.",

    "Handoff não é exceção invisível": "Handoff is not an invisible exception",
    "Quando um agente passa uma conversa para uma pessoa, a operação ganha uma decisão importante. Esse momento revela risco, dúvida, política, pressão de SLA ou valor do cliente.":
        "When an agent hands a conversation to a person, the team gains a meaningful decision point. That moment reveals risk, doubt, policy, SLA pressure or customer value.",
    "Se o registro fica solto, ninguém aprende. Se fica estruturado, ele vira material para QA, política e treinamento.":
        "If the record stays loose, nobody learns. If it is structured, it becomes material for QA, policy and training.",
    "O pacote mínimo de evidência": "The minimum evidence package",
    "Registre a transcrição, o resumo do caso, o motivo do handoff, a pessoa responsável, o SLA, a ação recomendada, o custo e o resultado final.":
        "Record the transcript, case summary, handoff reason, responsible person, SLA, recommended action, cost and final outcome.",
    "Esses campos permitem revisar se a validação humana foi correta, se o agente deveria ter resolvido sozinho ou se a política precisa mudar.":
        "Those fields make it possible to review whether human validation was correct, whether the agent should have resolved it alone or whether policy needs to change.",
    "Como isso melhora a operação": "How this improves operations",
    "Com evidência consistente, líderes deixam de avaliar agentes por sensação. Eles enxergam tendências, assuntos que escalam demais, políticas confusas, canais com mais risco e times que precisam de apoio.":
        "With consistent evidence, leaders stop evaluating agents by feel. They see trends, topics that escalate too often, unclear policies, riskier channels and teams that need support.",
    "A melhoria deixa de depender de reuniões longas e passa a vir do próprio fluxo de trabalho.":
        "Improvement stops depending on long meetings and starts coming from the workflow itself.",

    "Documentos não são todos iguais": "Documents are not all the same",
    "Extração simples pode ser automatizada. Decisão operacional exige mais cuidado: confiança do campo, completude, política aplicável e impacto do erro.":
        "Simple extraction can be automated. Operational decisions require more care: field confidence, completeness, applicable policy and impact of error.",
    "O fluxo precisa separar o que pode seguir sozinho do que deve voltar para uma pessoa com contexto suficiente para decidir rápido.":
        "The workflow needs to separate what can proceed alone from what must return to a person with enough context to decide quickly.",
    "Três sinais para revisão humana": "Three signals for human review",
    "Revise quando a confiança estiver baixa, quando faltar informação crítica ou quando a decisão afetar cliente, dinheiro, conformidade ou prazo.":
        "Review when confidence is low, when critical information is missing or when the decision affects a customer, money, compliance or a deadline.",
    "A revisão deve receber o documento, os campos extraídos, a dúvida do agente, a política aplicável e a próxima ação sugerida.":
        "The review should receive the document, extracted fields, the agent's question, the applicable policy and the suggested next action.",
    "O resultado precisa voltar para o sistema": "The outcome needs to return to the system",
    "Depois da revisão, o resultado deve atualizar o registro, fechar a tarefa e alimentar o histórico de qualidade.":
        "After review, the outcome should update the record, close the task and feed the quality history.",
    "Assim, cada exceção documental melhora o próximo ciclo em vez de virar retrabalho escondido.":
        "That way, each document exception improves the next cycle instead of becoming hidden rework.",
});

Object.assign(EN_US_TEXT, {
    "Blueprint do fluxo": "Workflow blueprint",
    "BLUEPRINT DO FLUXO": "WORKFLOW BLUEPRINT",
    "Ver página": "View page",
    "Privacidade": "Privacy",
    "Origem do símbolo": "Origin of the symbol",
    "arquitetura · segurança · implantação": "architecture · security · implementation",
    "implantação · governança · qualidade": "implementation · governance · quality",
    "assíncrono": "asynchronous",
    "escalação": "escalation",
    "Dúvidas devem seguir pelo": "Questions should go through",
    "suporte": "support",
});

Object.assign(EN_US_TEXT, {
    // Alt-text for generated/illustrative imagery
    "Mesa com tokens de créditos consumíveis organizados entre cartões de atividades.":
        "Desk with consumable credit tokens laid out among activity cards.",
    "Mesa com memorandos operacionais, caneta, café e esquemas abstratos de workflow.":
        "Desk with operational memos, a pen, coffee and abstract workflow sketches.",
    "Mesa de operação com cartões de workflow, telefone, documento e validação humana.":
        "Operations desk with workflow cards, a phone, a document and a human-validation note.",
    "Mesa escura com livro de auditoria, chave, documentos selados e trilha operacional.":
        "Dark desk with an audit ledger, a key, sealed documents and an operational trail.",
    "Mesa de trabalho com xícara de café, caderno e marca circular deixada pela conversa.":
        "Workspace with a coffee cup, a notebook and the circular mark a conversation leaves behind.",

    // Governance audit trail labels
    "Intenção": "Intent",
    "ação permitida": "action allowed",
    "responsável registrado": "owner on record",
    "evidência arquivada para QA": "evidence archived for QA",
    "Trilha de auditoria da operação": "Operational audit trail",
    "fila cobrança, operador Bruno assumiu": "collections queue, operator Bruno took the case",
    "cobrança_BR_v3, papel: agente_atendimento": "collections_BR_v3, role: service_agent",
    "cliente, pagamento pendente, confiança suficiente": "customer, payment pending, confidence sufficient",

    // Operating loop labels
    "Registro contínuo do turno": "Continuous turn record",
    "Como a Zild transforma solicitações em turnos operacionais":
        "How Zild turns requests into operational turns",

    // Product suite module labels
    "Extração": "Extraction",
    "Rastreável": "Traceable",
    "Por cenário": "By scenario",
    "Visível por canal": "Visible by channel",
    "Campos revisáveis": "Reviewable fields",
    "Revisão por critério": "Review by criterion",
    "Roteada por política": "Routed by policy",
    "Módulos da plataforma": "Platform modules",
    "Atendimento, recepção e prospecção por voz com transcrição em tempo real, scoring por chamada e revisão por monitoria.":
        "Service, reception and voice prospecting with live transcription, per-call scoring and monitoring review.",

    // Product surface mock UI labels
    "revisão": "review",
    "concluída": "completed",
    "Concluída": "Completed",
    "política aplicada": "policy applied",
    "Não consegui finalizar o pagamento.": "I couldn't complete the payment.",

    // Proof / results labels
    "Evidência publicada": "Evidence published",
    "motivo, transferência, callback, QA": "reason, transfer, callback, QA",
    "qualificação, follow-up, passagem, CRM": "qualification, follow-up, handoff, CRM",
    "transcrição, resumo e ponto de decisão": "transcript, summary and decision point",
    "completude, exceção, prazo, retrabalho": "completeness, exception, deadline, rework",
    "tarefa fechada com responsável e rastro": "task closed with owner and trail",
    "campos extraídos e checklist de validação": "extracted fields and validation checklist",
    "fila revisável por canal e tipo de exceção": "reviewable queue by channel and exception type",
    "histórico do lead com critério e próxima ação": "lead history with criteria and next action",
    "A faixa de impacto orienta a implantação sem virar promessa pública.":
        "The impact range guides rollout without becoming a public promise.",
    "O número só aparece com amostra, período, escopo e permissão do cliente.":
        "Numbers only go public with sample, period, scope and customer permission.",

    // Tech stack labels
    "Dados e ação": "Data and action",
    "Escolha por operação": "Choose by operation",
    "CRM, BI, ERP e storage ficam sob política.":
        "CRM, BI, ERP and storage stay under policy.",
    "Conversas entram onde o cliente já trabalha.":
        "Conversations come in where the customer already works.",

    // Use case cards
    "Operações": "Operations",
    "Qualidade contínua": "Ongoing quality",
    "Coach por simulação": "Coaching by simulation",
    "Prospecção governada": "Governed prospecting",
    "Completude, exceções e retrabalho": "Completeness, exceptions and rework",
    "Cobertura de QA e critérios por canal": "QA coverage and criteria by channel",
    "Responsável, prazo, risco e trilha auditável": "Owner, deadline, risk and an auditable trail",
    "Qualificação, follow-up e passagem para o time": "Qualification, follow-up and handoff to the team",
    "Tempo de resposta, handoff e qualidade por canal": "Response time, handoff and quality by channel",
    "Aderência ao script, coaching e evolução por pessoa":
        "Script adherence, coaching and per-person progress",
    "Outreach inicial, qualificação por critério e passagem para SDR humano com contexto completo.":
        "Initial outreach, criteria-based qualification and handoff to a human SDR with full context.",
    "Leitura de contratos, PDFs e formulários com extração estruturada e validação contra política.":
        "Reading contracts, PDFs and forms with structured extraction and policy validation.",
    "Roleplay por cenário, avaliação por critério e plano individual para humanos e para agentes de IA.":
        "Scenario roleplay, criteria-based evaluation and an individual plan for both humans and AI agents.",
    "Triagem, contexto, resposta e handoff humano em WhatsApp, voz e e-mail. SLA visível e qualidade revisável.":
        "Triage, context, response and human handoff on WhatsApp, voice and email. Visible SLA and reviewable quality.",
    "Scoring automático por chamada e por conversa, alinhado ao critério da operação. Revisão humana priorizada.":
        "Automatic scoring per call and conversation, aligned with operational criteria. Human review takes priority.",
    "Cobrança, recadastro, abertura e fechamento de tarefas internas, com limites de dado e auditoria por turno.":
        "Collections, re-registration, opening and closing internal tasks, with data limits and turn-by-turn audit.",

    // sitePages data
    "Projeto de IA sob medida para fluxos operacionais.":
        "Custom AI project for operational workflows.",

    // Contact page labels
    "Operações internas": "Internal operations",
    "Informe um e-mail corporativo válido": "Enter a valid corporate email",

    // Diagnostic page labels
    "Pontos de partida para diagnóstico": "Starting points for the diagnostic",

    // Company page label
    "Operamos em PT-BR para empresas brasileiras, com LGPD por design.":
        "We operate in pt-BR for Brazilian companies, with LGPD by design.",

    // Platform page labels
    "Histórico de uso para revisão": "Usage history for review",

    // Pricing labels
    "Créditos por atividade": "Credits by activity",

    // SitePage labels
    "Regra de operação": "Operating rule",
    "Módulos envolvidos": "Modules involved",
    "O padrão se adapta ao setor": "The pattern adapts to the industry",
    "Plano de controle de agentes": "Agent control plan",
    "Em vez de vender uma vertical genérica, a Zild parte do trabalho concreto: entrada, regra, responsável e evidência.":
        "Instead of selling a generic vertical, Zild starts from the concrete work: intake, rule, owner and evidence.",

    // Solucoes page label
    "Validação antes do go-live": "Validation before go-live",

    // Home page strings caught only at runtime (multi-line JSX, runtime composition)
    "Onde a operação passa a medir o que antes ficava invisível.":
        "Where operations finally measure what used to stay invisible.",
    "Cada agente sob política.": "Every agent under policy.",
    "Cada decisão sob trilha.": "Every decision on the trail.",
    "Evento por evento, com camada e registro.": "Event by event, with layer and record.",
    "Hash da trilha disponível para auditoria externa": "Trail hash available for external audit",
    "Camada de governança": "Governance layer",
    "política · roteamento · evidência": "policy · routing · evidence",
    "Impacto começa com linha de base, piloto e evidência.":
        "Impact starts with a baseline, a pilot and evidence.",
    "A Zild posiciona resultado como medição operacional: primeiro entende o fluxo real, depois define sinais de impacto e só então publica ganho comprovado.":
        "Zild treats outcomes as operational measurements: first understand the real workflow, then define impact signals, and only then publish proven gains.",
    "Evidência gerada": "Evidence produced",
    "O resultado pode ser auditado?": "Can the result be audited?",
    "Atender, classificar e transferir sem perder o contexto.": "Answer, classify and transfer without losing context.",
    "Adote IA na sua empresa com": "Adopt AI across your company with",
    "segurança, governança e controle de custos.": "security, governance and cost control.",
    "Saia do uso desestruturado para uma operação corporativa, multimodelo e mensurável. Comece por um caso de uso e expanda no seu ritmo, com até 75% de economia em licenças de IA.":
        "Move from scattered use to a measurable, multi-model enterprise operation. Start with one use case and expand at your pace, with up to 75% savings on AI licenses.",
    "Agende seu diagnóstico gratuito": "Book your free AI assessment",
    "Converse agora com nossa IA": "Talk to our AI now",
    "usuários ativos": "active users",
    "horas de projetos de IA": "hours of AI projects",
    "de economia em licenças": "savings on licenses",
    "dos atendimentos por WhatsApp, voz e e-mail resolvidos sem intervenção humana":
        "of WhatsApp, voice and email service requests resolved without human intervention",
    "Empresas que já operam com a Zild.": "Companies already operating with Zild.",
    "Parcerias oficiais": "Official partnerships",
    "Tecnologia e ecossistemas que ampliam nossa capacidade.": "Technology and ecosystems expanding our capabilities.",
    "Sua empresa já usa IA. A questão é como transformar uso disperso em resultado.":
        "Your company already uses AI. The question is how to turn scattered use into outcomes.",
    "Sobre a Zild": "About Zild",
    "Especialistas em Inteligência Artificial para empresas.":
        "Artificial Intelligence specialists for enterprises.",
    "Desde novembro de 2023, ajudamos empresas a transformar Inteligência Artificial em capacidade operacional real, conectando agentes a pessoas, processos e tecnologia.":
        "Since November 2023, we have helped enterprises turn Artificial Intelligence into real operational capability by connecting agents to people, processes and technology.",
    "Com a Zild Platform e Apps especializados, empresas podem começar por um caso de uso e evoluir com segurança, governança, liberdade de escolha e controle financeiro.":
        "With Zild Platform and specialized Apps, enterprises can start with one use case and evolve with security, governance, freedom of choice and financial control.",
    "Nossa missão": "Our mission",
    "Amplificar o potencial humano através da Inteligência Artificial.":
        "Amplify human potential through Artificial Intelligence.",
    "O que nos move": "What drives us",
    "Ambição brasileira, impacto humano.": "Brazilian ambition, human impact.",
    "Missão": "Mission",
    "Visão": "Vision",
    "Ser referência brasileira em Inteligência Artificial.":
        "Become Brazil's reference in Artificial Intelligence.",
    "Ecossistema": "Ecosystem",
    "Conectados às principais plataformas globais.": "Connected to leading global platforms.",
    "Somos parceiros oficiais da Microsoft, OpenAI, Meta Tech Provider para a API do WhatsApp e ElevenLabs.":
        "We are official partners of Microsoft, OpenAI, Meta Tech Provider for the WhatsApp API and ElevenLabs.",
    "Também fazemos parte do InovaBra, ecossistema de inovação do Bradesco, aproximando tecnologia, mercado e os desafios reais das grandes empresas.":
        "We are also part of InovaBra, Bradesco's innovation ecosystem, bringing technology and the market closer to the real challenges of large enterprises.",
    "Nosso manifesto": "Our manifesto",
    "O futuro não deve diminuir o ser humano.": "The future should not diminish human beings.",
    "Deve revelar sua grandeza.": "It should reveal their greatness.",
    "Acreditamos que toda pessoa merece tempo, espaço e liberdade para pensar além do óbvio, criar novas possibilidades e contribuir para um mundo melhor.":
        "We believe every person deserves the time, space and freedom to think beyond the obvious, create new possibilities and contribute to a better world.",
    "Acreditamos na felicidade como direção, nas pessoas como prioridade e na inteligência como instrumento de transformação. Porque empresas melhores começam com pessoas mais realizadas.":
        "We believe in happiness as a direction, people as the priority and intelligence as an instrument of transformation. Because better companies begin with more fulfilled people.",
    "Zild. Inteligência para ampliar o potencial humano.":
        "Zild. Intelligence to amplify human potential.",
    "Nossos valores": "Our values",
    "Como escolhemos construir.": "How we choose to build.",
    "Felicidade": "Happiness",
    "Construímos relações e ambientes em que pessoas possam realizar um trabalho relevante e ter orgulho do resultado.":
        "We build relationships and environments where people can do meaningful work and take pride in the outcome.",
    "Foco nas pessoas": "People first",
    "A tecnologia começa por uma necessidade humana e deve ampliar, nunca diminuir, a capacidade de quem a utiliza.":
        "Technology starts with a human need and should expand, never diminish, the capabilities of those who use it.",
    "Coragem": "Courage",
    "Enfrentamos problemas complexos, questionamos o caminho óbvio e assumimos decisões com responsabilidade.":
        "We face complex problems, challenge the obvious path and take responsibility for our decisions.",
    "Comprometimento": "Commitment",
    "Tratamos cada entrega e cada relação de longo prazo com senso de dono, consistência e transparência.":
        "We approach every delivery and long-term relationship with ownership, consistency and transparency.",
    "Respeito": "Respect",
    "Escutamos perspectivas diferentes e construímos confiança com clientes, parceiros e pessoas do time.":
        "We listen to different perspectives and build trust with customers, partners and team members.",
    "Aprendizado contínuo": "Continuous learning",
    "Aprendemos com dados, experiências e mudanças tecnológicas para evoluir todos os dias.":
        "We learn from data, experience and technological change to improve every day.",
    "Informações corporativas": "Corporate information",
    "Empresa brasileira de tecnologia fundada em novembro de 2023.":
        "Brazilian technology company founded in November 2023.",
    "Razão social": "Legal name",
    "Nome fantasia": "Trade name",
    "Endereço": "Address",
    "A IA deve ampliar a capacidade da empresa sem tirar dela o controle.":
        "AI should expand the enterprise's capabilities without taking away its control.",
    "A visão da Zild é transformar a IA de um conjunto disperso de ferramentas em uma camada operacional que conecta pessoas, processos e tecnologia. Uma camada capaz de atender, analisar e executar, sempre dentro das regras definidas pela empresa.":
        "Zild's vision is to turn AI from a scattered set of tools into an operational layer connecting people, processes and technology. A layer able to serve, analyze and execute, always within the rules defined by the enterprise.",
    "Modelos e fornecedores vão mudar. A empresa não deveria reconstruir sua operação a cada nova tecnologia. Por isso, criamos uma plataforma multimodelo que preserva a liberdade de escolha e centraliza segurança, governança, ModelOps e FinOps.":
        "Models and providers will change. The enterprise should not have to rebuild its operation for every new technology. That is why we built a multimodel platform that preserves freedom of choice and centralizes security, governance, ModelOps and FinOps.",
    "Nossa visão": "Our vision",
    "IA em escala, com a empresa no controle.": "AI at scale, with the enterprise in control.",
    "Da intenção à operação": "From intent to operations",
    "A Zild ajuda a escolher o primeiro caso de uso, colocar agentes em produção e expandir com segurança, governança e previsibilidade financeira.":
        "Zild helps select the first use case, put agents into production and expand with security, governance and financial predictability.",
    "Comece com direção": "Start with direction",
    "Diagnóstico, recomendações e plano inicial em uma conversa de uma hora.":
        "Assessment, recommendations and an initial plan in a one-hour conversation.",
    "Evolua sem trocar de plataforma": "Evolve without changing platforms",
    "Comece por um caso de uso e amplie canais, Apps e volume.":
        "Start with one use case and expand channels, Apps and volume.",
    "Mantenha a empresa no controle": "Keep the enterprise in control",
    "Políticas, custos, modelos, acessos, auditoria e handoffs visíveis.":
        "Policies, costs, models, access, audit and handoffs remain visible.",
    "Diagnóstico gratuito · 1 hora": "Free assessment · 1 hour",
    "O que você recebe na conversa": "What you get from the conversation",
    "Diagnóstico": "Assessment",
    "Leitura do cenário, maturidade, prioridades e riscos atuais.":
        "A review of the current scenario, maturity, priorities and risks.",
    "Recomendações": "Recommendations",
    "Alternativas de plataforma, modelos, governança e primeiro caso.":
        "Platform, model, governance and first-use-case options.",
    "Plano inicial": "Initial plan",
    "Próximos passos, escopo do piloto e critérios para medir valor.":
        "Next steps, pilot scope and criteria for measuring value.",
    "A origem da marca": "The origin of the brand",
    "Uma conversa deixa rastro.": "A conversation leaves a trace.",
    "Fundadores": "Founders",
    "Experiência para transformar IA em operação.": "Experience to turn AI into operations.",
    "CEO e CTO": "CEO and CTO",
    "Zild vem de Zilda, avó da Ana, cofundadora da Zild. O símbolo vem da marca que uma xícara de café deixa na mesa depois de uma conversa: alguém esteve presente, algo foi decidido e uma evidência ficou para ser revisada.":
        "Zild comes from Zilda, grandmother of Ana, Zild's cofounder. The symbol comes from the mark a coffee cup leaves on the table after a conversation: someone was present, something was decided and evidence remained to be reviewed.",
    "Essa origem resume nossa tese: IA só deve operar quando existe contexto humano antes da ação, responsabilidade durante a execução e uma trilha clara depois dela.":
        "That origin sums up our thesis: AI should operate only when there is human context before the action, accountability during execution and a clear trail afterward.",
    "Liberdade para escolher e trocar modelos de IA.": "Freedom to choose and switch AI models.",
    "Uma plataforma conectada ao trabalho real.": "One platform connected to real work.",
    "Resultados reais": "Real outcomes",
    "IA aplicada ao que move a operação.": "AI applied to what moves the operation.",
    "Ver todos os cases": "See all case studies",
    "Baixar gratuitamente": "Download for free",
    "Ver todos os estudos": "See all studies",
    "Em 1 hora, saia com um plano inicial para adotar IA.": "In one hour, leave with an initial AI adoption plan.",
    "Agendar diagnóstico gratuito": "Book a free assessment",
});
